import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import DropDownComp from "./DropDownComp";
import DateTimePicker from "react-datetime-picker";
import InputComp from "./InputComp";
import CheckboxComponent from "./CheckboxComp";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";
import CreatableSelect from "react-select/creatable";
import Encrypt from "./../util/encrypt";
import "./../assets/css/datePicker.css";
import { moveTypeStatus } from "../util/constants/enumValue";
import {
  getCurrentDoorOccupancy,
  getCurrentSpaceOccupancy,
} from "../services/ApiUtils";

const MovesModalComponent = (props) => {
  const dispatch = useDispatch();
  const creatableInputRef = useRef(null);

  const [previousLoadVolume, setPreviousLoadVolume] = useState(
    props.rowDataUser?.trailer?.prevLoadVolume
      ? {
          value: props.rowDataUser.trailer?.prevLoadVolume,
          label: props.rowDataUser.trailer?.prevLoadVolume,
        }
      : ""
  );

  const [newLoadVolume, setNewLoadVolume] = useState(
    props.rowDataUser?.newLoadVolume
      ? {
          value: props.rowDataUser.newLoadVolume,
          label: props.rowDataUser.newLoadVolume,
        }
      : ""
  );

  const [requestTime, setRequestTime] = useState(
    props.rowDataUser?.startDateTime
      ? props.rowDataUser.startDateTime
      : new Date()
  );

  const [requestFinishTime, setRequestFinishTime] = useState(new Date());

  const [requesterName, setRequesterName] = useState(
    props.rowDataUser?.requesterName ? props.rowDataUser.requesterName : null
  );

  const [userId, setUserId] = useState(
    props.rowDataUser?.user_id ? props.rowDataUser.user_id : null
  );

  const [totalTime, setTotalTime] = useState();

  const [moveType, setMoveType] = useState(
    props.rowDataUser && props.rowDataUser.changeType
      ? {
          value: props.rowDataUser.changeType,
          label: props.rowDataUser.changeType,
        }
      : ""
  );

  const [departmentType, setDepartmentType] = useState("");

  const [driver, setDriver] = useState(
    props.rowDataUser && props.rowDataUser.driver
      ? {
          value: props.rowDataUser.driver?.user_id,
          label:
            props.rowDataUser.driver?.firstName +
            " " +
            props.rowDataUser.driver?.lastName,
        }
      : ""
  );

  const [truck, setTruck] = useState(
    props.rowDataUser && props.rowDataUser.truck
      ? {
          value: props.rowDataUser.truck?.truck_id,
          label:
            props.rowDataUser.truck?.type +
            "_" +
            props.rowDataUser.truck?.bt_id,
        }
      : ""
  );

  const [sealNumber, setSealNumber] = useState(
    props.rowDataUser && props.rowDataUser.sealNum
      ? props.rowDataUser.sealNum
      : ""
  );

  const [productNumber, setProductNumber] = useState(
    props.rowDataUser && props.rowDataUser.productNum
      ? props.rowDataUser.productNum
      : ""
  );

  const [actualCount, setActualCount] = useState(
    props.rowDataUser && props.rowDataUser.actualCount
      ? props.rowDataUser.actualCount
      : ""
  );

  const [comment, setComment] = useState(
    props.rowDataUser && props.rowDataUser.beforeComments
      ? props.rowDataUser.beforeComments
      : ""
  );

  const [afterComment, setAfterComment] = useState(
    props.rowDataUser && props.rowDataUser.afterComments
      ? props.rowDataUser.afterComments
      : ""
  );

  const [division, setDivision] = useState(
    props.rowDataUser && props.rowDataUser.division
      ? {
          value: props.rowDataUser.division.division_id,
          label: props.rowDataUser.divisionName,
        }
      : ""
  );

  const [doorTo, setDoorTo] = useState(
    props.rowDataUser && props.rowDataUser.doorTo
      ? props.rowDataUser.doorTo
      : ""
  );

  const [doorFrom, setDoorFrom] = useState(
    props.rowDataUser && props.rowDataUser.doorFrom
      ? props.rowDataUser.doorFrom
      : ""
  );

  //move
  const [department, setDepartment] = useState(
    props.rowDataUser && props.rowDataUser.department
      ? {
          value: props.rowDataUser.department,
          label: props.rowDataUser.department,
        }
      : ""
  );

  const [divisionArr, setDivisionArr] = useState([]);

  const [changeType, setChangeType] = useState(
    props.rowDataUser && props.rowDataUser.changeType
      ? {
          value: props.rowDataUser.changeType,
          label: props.rowDataUser.changeType,
        }
      : ""
  );

  const [driverTypeArr, setDriverTypeArr] = useState([]);

  const [truckTypeArr, setTruckTypeArr] = useState([]);

  const truckTypeArrLocal = useSelector((state) => state.truck.getTruckData);

  const driverNameArrLocal = useSelector((state) => state.driver.getdriverData);

  const [doorToArray, setdoorToArray] = useState([]);

  const [doorFromArray, setdoorFromArray] = useState([]);

  const [trailerIdArray, setTrailerIdArray] = useState([]);

  const [containerIdArray, setContainerIdArray] = useState([]);

  const [isTrailer, setIsTrailer] = useState(true);

  const [isContainer, setIsContainer] = useState(false);

  const [trailerId, setTrailerId] = useState(
    props.rowDataUser && props.rowDataUser.trailer
      ? {
          value: props.rowDataUser.trailer.id,
          label: props.rowDataUser.trailer.btId,
        }
      : null
  );

  const [containerId, setContainerId] = useState(null);

  const [currentLocation, setCurrentLocation] = useState("");

  const [isTrailerContainerChecked, setIsTrailerContainerChecked] = useState(
    props.rowDataUser?.isEmpty != null ? props.rowDataUser?.isEmpty : false
  );

  const [priorityMove, setIsPriorityMove] = useState(
    props.rowDataUser?.priorityMove ? props.rowDataUser?.priorityMove : false
  );

  //Space To Space
  const [lotFrom, setLotFrom] = useState(
    props.rowDataUser?.lotFromId != null && props.rowDataUser?.lotFrom != null
      ? {
          value: props.rowDataUser?.lotFrom?.lot_id,
          label: props.rowDataUser?.lotFrom?.lotName,
        }
      : null
  );

  const [lotTo, setLotTo] = useState(
    props.rowDataUser?.lotFromId != null && props.rowDataUser?.lotTo != null
      ? {
          value: props.rowDataUser?.lotTo?.lot_id,
          label: props.rowDataUser?.lotTo?.lotName,
        }
      : null
  );

  const [lotFromArr, setLotFromArray] = useState([]);

  const [lotArray, setLotArray] = useState([]);

  const [lotToArr, setLotToArray] = useState([]);
  const [divisionTo, setDivisionTo] = useState("");

  const [spaceFromArr, setSpaceFromArray] = useState([]);
  const [spaceFrom, setSpaceFrom] = useState("");

  const [spaceToArr, setSpaceToArray] = useState([]);
  const [spaceTo, setSpaceTo] = useState("");

  const [locationFrom, setLocationFrom] = useState("");
  const [locationTo, setLocationTo] = useState("");
  const [activeUsers, setActiveUsers] = useState([]);
  const rowDataDepartmentTemp = useSelector(
    (state) => state.department.getDepartmentData
  );
  const [departmentTypeArr, setDepartmentTypeArr] = useState([]);
  const [moveTypeArr, setMoveTypeArr] = useState([
    { label: "Door In", value: "DOORIN" },
    { label: "Door Out", value: "DOOROUT" },
    { label: "RESET", value: "RESET" },
    { label: "Space To Space", value: "SPACE2SPACE" },
    { label: "Door To Door", value: "DOOR2DOOR" },
  ]);
  const [loginResponse, setLoginResponse] = useState(null);

  const [reasonCancellationArr, setReasonCancellationArr] = useState([
    { label: "No Issue", value: "No Issue" },
    { label: "Cancelled By Hanes", value: "Cancelled By Hanes" },
    { label: "Incorrect Input", value: "Incorrect Input" },
    { label: "Red Light", value: "Red Light" },
    { label: "Trailer Issue", value: "Trailer Issue" },
    { label: "Wrong Space", value: "Wrong Space" },
  ]);

  const [reasonForCancellation, setReasonForCancellation] = useState({
    label: "No Issue",
    value: "No Issue",
  });

  const [loadVolumeArr, setLoadVolumeArr] = useState([
    { label: "FULL", value: "FULL" },
    { label: "PARTIALLY FULL", value: "PARTIALLY FULL" },
    { label: "EMPTY", value: "EMPTY" },
  ]);

  const rowDataDivision = useSelector(
    (state) => state.division.getDivisionData
  );

  const rowDataLot = useSelector((state) => state.lots.getLotData);

  const rowDataDoorForMove = useSelector((state) => state.doors.getDoorForMove);

  const rowDataTrailer = useSelector(
    (state) => state.trailerManagement.getTrailerData
  );

  const containerArray = useSelector((state) => state.move.getContainerData);

  const rowSpaceFromArray = useSelector((state) => state.move.getSpaceFromData);

  const rowSpaceToArray = useSelector((state) => state.move.getSpaceToData);

  const rowDataRuralLog = useSelector(
    (state) => state.ruralTrailer.getRuralTrailerLogsData
  );

  const rowContainerData = useSelector(
    (state) => state.move.createContainerData
  );

  const rowActiveDataUser = useSelector(
    (state) => state.userManagement.getActiveUserData
  );
  const [isCancelledClick, setIsCancelClicked] = useState(false);
  const [YardFromArr, setYardFromArr] = useState([]);

  const [pageNo, setPage] = useState(0);
  const [createContainerEnable, setCreateContainerEnable] = useState(false);

  const divisionsArrayTemp = useSelector(
    (state) => state.division.getDivisionData
  );
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );
  const [divisionsArray, setDivisionArray] = useState([]);
  const [divisionDC2DCArr, setDivisionDC2DCArr] = useState([]);
  const [divisionDC2DC, setDivisionDC2DC] = useState();

  const getSpaceByLotData = useSelector(
    (state) => state.lots.getSpaceByLotData
  );
  const [spaceDC2SpaceArray, setSpaceDC2SpaceArray] = useState([]);
  const [spaceDC2SpaceValue, setSpaceDC2SpaceValue] = useState("");

  useEffect(() => {
    if (
      rowDataDepartmentTemp &&
      rowDataDepartmentTemp.length > 0 &&
      rowDataDepartmentTemp != "Failed"
    ) {
      let activeDepartmentData = rowDataDepartmentTemp.filter(
        (item) => item.is_active == true
      );
      var data = [];
      for (var i = 0; i < activeDepartmentData.length; i++) {
        data.push({
          value: activeDepartmentData[i]?.departmentName,
          label: activeDepartmentData[i]?.departmentName,
        });
      }
      setDepartmentTypeArr(data);
    }
  }, [rowDataDepartmentTemp]);

  useEffect(() => {
    let data = [];
    if (getSpaceByLotData && getSpaceByLotData?.length) {
      for (let i = 0; i < getSpaceByLotData.length; i++) {
        data.push({
          label: getSpaceByLotData[i].btId,
          value: getSpaceByLotData[i].space_id,
        });
      }
      setSpaceDC2SpaceArray(data);
    }
  }, [getSpaceByLotData]);

  useEffect(() => {
    if (rowActiveDataUser?.length > 0 && rowActiveDataUser != "Failed") {
      var data = [];
      for (var i = 0; i < rowActiveDataUser.length; i++) {
        data.push({
          value: rowActiveDataUser[i]?.user_id,
          label:
            (rowActiveDataUser[i]?.firstName != undefined
              ? rowActiveDataUser[i]?.firstName
              : "") +
            " " +
            (rowActiveDataUser[i]?.lastName != undefined
              ? rowActiveDataUser[i]?.lastName
              : ""),
        });
      }
      setActiveUsers(data);
    }
  }, [rowActiveDataUser]);

  useEffect(() => {
    if (requesterName != "" && requesterName != null && userId != null) {
      setRequesterName({
        label:
          props.rowDataUser?.requesterName != undefined
            ? props.rowDataUser?.requesterName
            : "",
        value: props.rowDataUser?.user_id,
      });
    } else {
      let localstorageLR = localStorage.getItem("L_R");
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let name = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.firstName
          : ""
        : "";
      let userId = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.user_id
          : ""
        : "";
      setRequesterName({ label: name, value: userId });
    }

    //location
    if (props.rowDataUser?.trailer && props.rowDataUser?.trailer != null) {
      let obj = {
        id:
          props.rowDataUser?.trailer?.id != undefined
            ? props.rowDataUser?.trailer?.id
            : 0,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
          .GET_RURAL_TRAILER_LOGS_API_CALL,
        payload: { value: obj },
      });
    } else {
      setCurrentLocation("");
    }

    if (divisionsArrayTemp) {
      var data = [],
        dataDC2DC = [];
      if (props.rowDataUser && props.rowDataUser?.division_id != null) {
        setDivision({
          label: props.rowDataUser?.division?.divisionName,
          value: props.rowDataUser?.division?.division_id,
        });
        if (
          !(
            loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.ADMIN
          )
        ) {
          for (var i = 0; i < divisionsArrayTemp.length; i++) {
            if (
              divisionsArrayTemp[i].division_id == props.rowData?.division_id
            ) {
              data.push({
                label: divisionsArrayTemp[i].divisionName,
                value: divisionsArrayTemp[i].division_id,
                isdisabled: false,
              });
            } else {
              data.push({
                label: divisionsArrayTemp[i].divisionName,
                value: divisionsArrayTemp[i].division_id,
                isdisabled: true,
              });
            }
          }
          setDivisionArray(data);
        } else {
          for (var i = 0; i < divisionsArrayTemp.length; i++) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
            });
          }
          setDivisionArray(data);
        }
      } else if (
        divisionSelectedTemp &&
        divisionSelectedTemp != null &&
        divisionSelectedTemp != ""
      ) {
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (divisionsArrayTemp[i].division_id == divisionSelectedTemp.value) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          } else {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
          }
        }
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (divisionsArrayTemp[i].division_id == divisionSelectedTemp.value) {
            dataDC2DC.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
          } else {
            dataDC2DC.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          }
        }
        setDivisionDC2DCArr(dataDC2DC);
        setDivisionArray(data);
        setDivision({
          value: divisionSelectedTemp.value,
          label: divisionSelectedTemp.label,
        });
      } else {
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          data.push({
            label: divisionsArrayTemp[i].divisionName,
            value: divisionsArrayTemp[i].division_id,
          });
        }
        setDivisionArray(data);
      }
    } else {
      setDivision(divisionSelectedTemp);
    }

    if (truckTypeArrLocal && truckTypeArrLocal.length > 0) {
      var data = [];
      for (var i = 0; i < truckTypeArrLocal.length; i++) {
        if (
          truckTypeArrLocal[i].is_active === true &&
          truckTypeArrLocal[i].division.division_id ===
            divisionSelectedTemp?.value
        ) {
          data.push({
            label: truckTypeArrLocal[i].type + "_" + truckTypeArrLocal[i].bt_id,
            value: truckTypeArrLocal[i].truck_id,
          });
        }
      }
      setTruckTypeArr(data);
    }

    if (driverNameArrLocal && driverNameArrLocal.length > 0) {
      var data = [];
      for (var i = 0; i < driverNameArrLocal.length; i++) {
        if (driverNameArrLocal[i].is_active === true) {
          data.push({
            label:
              driverNameArrLocal[i]?.firstName +
              " " +
              driverNameArrLocal[i]?.lastName,
            value: driverNameArrLocal[i]?.user_id,
          });
        }
      }

      setDriverTypeArr(data);
    }

    if (rowDataDivision && rowDataDivision.length > 0) {
      var data = [];
      for (var i = 0; i < rowDataDivision.length; i++) {
        data.push({
          label: rowDataDivision[i].divisionName,
          value: rowDataDivision[i].division_id,
        });
      }
      setDivisionArr(data);
    }

    if (rowDataTrailer && rowDataTrailer.length > 0) {
      var data = [];
      let obj = {
        id: trailerId?.value != undefined ? trailerId?.value : 0,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
          .GET_RURAL_TRAILER_LOGS_API_CALL,
        payload: { value: obj },
      });

      for (var i = 0; i < rowDataTrailer.length; i++) {
        data.push({
          label: rowDataTrailer[i].btId,
          value: rowDataTrailer[i]?.id,
          currentLoad: rowDataTrailer[i]?.currentLoad,
        });
      }
      setTrailerIdArray(data);
    }

    if (
      props.rowDataUser?.doorFromId != null &&
      rowDataDoorForMove.length > 0 &&
      rowDataDoorForMove != "Failed"
    ) {
      let doorArr = rowDataDoorForMove?.filter(
        (item) => item.door_id == props.rowDataUser?.doorFrom?.door_id
      );
      if (doorArr.length > 0) {
        setDoorFrom({
          label:
            doorArr[0].doorType +
            "_" +
            doorArr[0].number +
            "_" +
            (doorArr[0].btId != null
              ? doorArr[0].btId
              : doorArr[0].containerBtId != null
              ? doorArr[0].containerBtId
              : "EMPTY"),
          value: doorArr[0].door_id,
        });
      }

      if (
        doorArr[0].containerBtId != null &&
        doorArr[0].outsideCarrierContainer_id != null
      ) {
        setIsTrailer(false);
        setIsContainer(true);
        setTrailerId("");
        setContainerId({
          value: doorArr[0].outsideCarrierContainer_id
            ? doorArr[0].outsideCarrierContainer_id
            : "",
          label: doorArr[0].containerBtId ? doorArr[0].containerBtId : "",
        });
      }
    }

    if (props.rowDataUser?.doorToId != null && rowDataDoorForMove.length > 0) {
      let doorArr = rowDataDoorForMove?.filter(
        (item) => item.door_id == props.rowDataUser?.doorTo?.door_id
      );
      let trailerValue =
        doorArr[0].currentOccupancy != null
          ? "_TRAILER"
          : doorArr[0]?.outsideCarrierContainer_id != null
          ? "_CONTAINER"
          : "_EMPTY";

      if (doorArr.length > 0) {
        if (
          doorArr[0].containerBtId != null &&
          doorArr[0].outsideCarrierContainer_id != null
        ) {
          setIsTrailer(false);
          setIsContainer(true);
          setTrailerId("");
        }
        setDoorTo({
          label:
            doorArr[0].doorType +
            "_" +
            doorArr[0].number +
            "_" +
            (doorArr[0].btId && doorArr[0].btId != null
              ? doorArr[0].btId
              : "EMPTY"),
          value: doorArr[0].door_id,
        });
      }
    }

    //move type space to Space

    if (rowDataLot?.length > 0) {
      if (props.rowDataUser?.lotToId != null) {
        //get lot
        let lotArray = rowDataLot?.filter(
          (item) => item.lot_id == props.rowDataUser.lotToId
        );
        setLotTo({
          label: lotArray[0].lotName,
          value: lotArray[0].lot_id,
          spaces: lotArray[0].spaces,
          division_id: lotArray[0].division_id,
          divisionName: lotArray[0].division.divisionName,
        });

        let lotDivisionArray = rowDataLot?.filter(
          (item) => item.division_id == divisionSelectedTemp?.value
        );

        let data = [];
        for (var i = 0; i < lotDivisionArray.length; i++) {
          if (props.rowDataUser?.lotFromId != null) {
            if (lotDivisionArray[i].lot_id == props.rowDataUser?.lotFromId) {
              data.push({
                label: lotDivisionArray[i].lotName,
                value: lotDivisionArray[i].lot_id,
                spaces: lotDivisionArray[i].spaces,
                division_id: lotDivisionArray[i].division_id,
                divisionName: lotDivisionArray[i].divisionName,
                isdisabled: true,
              });
            } else {
              data.push({
                label: lotDivisionArray[i].lotName,
                value: lotDivisionArray[i].lot_id,
                spaces: lotDivisionArray[i].spaces,
                division_id: lotDivisionArray[i].division_id,
                divisionName: lotDivisionArray[i].divisionName,
              });
            }
          } else {
            data.push({
              label: lotDivisionArray[i].lotName,
              value: lotDivisionArray[i].lot_id,
              spaces: lotDivisionArray[i].spaces,
              division_id: lotDivisionArray[i].division_id,
              divisionName: lotDivisionArray[i].divisionName,
            });
          }
        }
        setLotToArray(data);
      }
      if (props.rowDataUser?.lotFromId != null) {
        //get lot
        let lotArray = rowDataLot?.filter(
          (item) => item.lot_id == props.rowDataUser.lotFromId
        );
        setLotFrom({
          label: lotArray[0].lotName,
          value: lotArray[0].lot_id,
          spaces: lotArray[0].spaces,
          division_id: lotArray[0].division_id,
          divisionName: lotArray[0].division.divisionName,
        });

        let lotDivisionArray = rowDataLot?.filter(
          (item) => item.division_id == divisionSelectedTemp?.value
        );
        let data = [];
        for (var i = 0; i < lotDivisionArray.length; i++) {
          data.push({
            label: lotDivisionArray[i].lotName,
            value: lotDivisionArray[i].lot_id,
            spaces: lotDivisionArray[i].spaces,
            division_id: lotDivisionArray[i].division_id,
            divisionName: lotDivisionArray[i].divisionName,
          });
        }
        setYardFromArr(data);
      } else {
        let data = [];
        let rowDataLotTemp = rowDataLot?.filter(
          (item) =>
            parseInt(item.division_id) === parseInt(divisionSelectedTemp?.value)
        );
        for (var i = 0; i < rowDataLotTemp?.length; i++) {
          data.push({
            label: rowDataLotTemp[i].lotName,
            value: rowDataLotTemp[i].lot_id,
            spaces: rowDataLotTemp[i].spaces,
            division_id: rowDataLotTemp[i].division_id,
            divisionName: rowDataLotTemp[i].divisionName,
          });
        }

        setLotToArray(data);
        setYardFromArr(data);
      }
    }

    if (division && division != null) {
      if (moveType?.value == "SPACE2SPACE" || moveType?.value == "DC2SPACE") {
        var lotArr = rowDataLot?.filter(
          (item) => item.division_id == divisionSelectedTemp.value
        );

        if (lotArr.length > 0) {
          let data = [];
          for (var i = 0; i < lotArr.length; i++) {
            data.push({
              label: lotArr[i].lotName,
              value: lotArr[i].lot_id,
              spaces: lotArr[i].spaces,
            });
          }
          //Lot From Id & Lot To Id
          if (props.rowDataUser?.lotFromId != null && divisionArr.length > 0) {
            var lotFromIdTemp = data.filter(
              (item) => item.value == props.rowDataUser?.lotFromId
            );
            setLotFrom({
              value: lotFromIdTemp[0].value,
              label: lotFromIdTemp[0].label,
            });
          }
          setLotFromArray(data);

          if (props.rowDataUser?.lotToId != null && divisionArr.length > 0) {
            var lotToIdTemp = data.filter(
              (item) => item.value == props.rowDataUser?.lotToId
            );
            setLotTo({
              value: lotToIdTemp[0].value,
              label: lotToIdTemp[0].label,
            });
          }
          setLotToArray(data);
        } else {
          let obj = {
            division_id: divisionSelectedTemp?.value,
          };
          dispatch({
            type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
              .GET_LOTS_BY_DIVISION_MANAGEMENT_API_CALL,
            payload: { value: obj },
          });
        }

        if (
          props.rowDataUser?.spaceFromId != null &&
          props.rowDataUser?.spaceFrom != null
        ) {
          setSpaceFrom({
            label: props.rowDataUser?.spaceFrom?.btId + "_" + "EMPTY",
            value: props.rowDataUser?.spaceFrom.space_id,
          });
        }
      } else if (moveType?.value == "DOOROUT") {
        var lotArr = rowDataLot?.filter(
          (item) => item.division_id == divisionSelectedTemp.value
        );

        if (lotArr.length > 0) {
          let data = [];
          for (var i = 0; i < lotArr.length; i++) {
            data.push({
              label: lotArr[i].lotName,
              value: lotArr[i].lot_id,
              spaces: lotArr[i].spaces,
            });
          }
          //Lot From Id & Lot To Id
          if (props.rowDataUser?.lotFromId != null && divisionArr.length > 0) {
            var lotFromIdTemp = data.filter(
              (item) => item.value == props.rowDataUser?.lotFromId
            );
            setLotFrom({
              value: lotFromIdTemp[0].value,
              label: lotFromIdTemp[0].label,
            });
          }
          setLotFromArray(data);

          if (props.rowDataUser?.lotToId != null && divisionArr.length > 0) {
            var lotToIdTemp = data.filter(
              (item) => item.value == props.rowDataUser?.lotToId
            );
            setLotTo({
              value: lotToIdTemp[0].value,
              label: lotToIdTemp[0].label,
            });
          }
          setLotToArray(data);
        } else {
          let obj = {
            division_id: divisionSelectedTemp?.value,
          };
          dispatch({
            type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
              .GET_LOTS_BY_DIVISION_MANAGEMENT_API_CALL,
            payload: { value: obj },
          });
        }

        if (
          rowDataDoorForMove &&
          rowDataDoorForMove.length > 0 &&
          rowDataDoorForMove != "Failed"
        ) {
          var data = [];
          let doorForMoveArray = rowDataDoorForMove.filter(
            (item) => item.division_id == divisionSelectedTemp?.value
          );
          for (var i = 0; i < doorForMoveArray.length; i++) {
            let trailerValue =
              doorForMoveArray[i].currentOccupancy != null
                ? "_TRAILER"
                : doorForMoveArray[i]?.outsideCarrierContainer_id != null
                ? "_CONTAINER"
                : "_EMPTY";
            if (
              moveType?.value == "DOOROUT" ||
              moveType?.value == "RESET" ||
              moveType?.value == "DOOR2DOOR"
            ) {
              data.push({
                label:
                  doorForMoveArray[i].doorType +
                  "_" +
                  doorForMoveArray[i].number +
                  "_" +
                  (doorForMoveArray[i].btId != null
                    ? doorForMoveArray[i].btId
                    : doorForMoveArray[i].containerBtId != null
                    ? doorForMoveArray[i].containerBtId
                    : "EMPTY"),
                value: doorForMoveArray[i]?.door_id,
                trailerId: doorForMoveArray[i]?.btId,
                containerId: doorForMoveArray[i]?.outsideCarrierContainer_id,
                containerBtId: doorForMoveArray[i]?.containerBtId,
                isTrailer: doorForMoveArray[i].btId != null ? true : false,
                isContainer:
                  doorForMoveArray[i].containerBtId != null ? true : false,
                isdisabled:
                  doorForMoveArray[i].btId == null &&
                  doorForMoveArray[i].containerBtId == null
                    ? true
                    : false,
              });
              setdoorFromArray(data);
            } else {
              data.push({
                label:
                  doorForMoveArray[i].doorType +
                  "_" +
                  doorForMoveArray[i].number +
                  "_" +
                  (doorForMoveArray[i].btId
                    ? doorForMoveArray[i].btId
                    : doorForMoveArray[i].containerBtId != null
                    ? doorForMoveArray[i].containerBtId
                    : "EMPTY"),
                value: doorForMoveArray[i].door_id,
                isdisabled:
                  doorForMoveArray[i].btId != null ||
                  doorForMoveArray[i].containerBtId != null
                    ? true
                    : false,
              });
              setdoorToArray(data);
            }
          }
        }
      } else if (moveType?.value == "DOORIN" || moveType?.value == "RESET") {
        if (
          rowDataDoorForMove &&
          rowDataDoorForMove.length > 0 &&
          rowDataDoorForMove != "Failed"
        ) {
          var data = [];
          let doorForMoveArray = rowDataDoorForMove?.filter(
            (item) => item.division_id == divisionSelectedTemp?.value
          );
          for (var i = 0; i < doorForMoveArray.length; i++) {
            let trailerValue =
              doorForMoveArray[i].currentOccupancy != null
                ? "_TRAILER"
                : doorForMoveArray[i]?.outsideCarrierContainer_id != null
                ? "_CONTAINER"
                : "_EMPTY";
            if (moveType?.value == "DOOROUT" || moveType?.value == "RESET") {
              data.push({
                label:
                  doorForMoveArray[i].doorType +
                  "_" +
                  doorForMoveArray[i].number +
                  "_" +
                  (doorForMoveArray[i].btId != null
                    ? doorForMoveArray[i].btId
                    : doorForMoveArray[i].containerBtId != null
                    ? doorForMoveArray[i].containerBtId
                    : "EMPTY"),
                value: doorForMoveArray[i].door_id,
                trailerId: doorForMoveArray[i].btId,
                isdisabled:
                  doorForMoveArray[i].btId == null &&
                  doorForMoveArray[i].containerBtId == null
                    ? true
                    : false,
                trailerId: doorForMoveArray[i]?.btId,
                containerId: doorForMoveArray[i]?.outsideCarrierContainer_id,
                containerBtId: doorForMoveArray[i]?.containerBtId,
                isTrailer: doorForMoveArray[i].btId != null ? true : false,
                isContainer:
                  doorForMoveArray[i].containerBtId != null ? true : false,
              });
              setdoorFromArray(data);
            } else {
              data.push({
                label:
                  doorForMoveArray[i].doorType +
                  "_" +
                  doorForMoveArray[i].number +
                  "_" +
                  (doorForMoveArray[i].btId
                    ? doorForMoveArray[i].btId
                    : doorForMoveArray[i].containerBtId != null
                    ? doorForMoveArray[i].containerBtId
                    : "EMPTY"),
                value: doorForMoveArray[i].door_id,
                isdisabled:
                  doorForMoveArray[i].btId != null ||
                  doorForMoveArray[i].containerBtId != null
                    ? true
                    : false,
              });
              setdoorToArray(data);
            }
          }
        }
      } else if (moveType?.value === "DOOR2DOOR") {
        if (
          rowDataDoorForMove &&
          rowDataDoorForMove.length > 0 &&
          rowDataDoorForMove != "Failed"
        ) {
          var dataFrom = [],
            dataTo = [],
            data = [];
          let doorForMoveArray = rowDataDoorForMove.filter(
            (item) => item.division_id == divisionSelectedTemp?.value
          );
          for (var i = 0; i < doorForMoveArray.length; i++) {
            dataFrom.push({
              label:
                doorForMoveArray[i].doorType +
                "_" +
                doorForMoveArray[i].number +
                "_" +
                (doorForMoveArray[i].btId != null
                  ? doorForMoveArray[i].btId
                  : doorForMoveArray[i].containerBtId != null
                  ? doorForMoveArray[i].containerBtId
                  : "EMPTY"),
              value: doorForMoveArray[i].door_id,
              isdisabled:
                doorForMoveArray[i].btId == null &&
                doorForMoveArray[i].containerBtId == null
                  ? true
                  : false,
              trailerId: doorForMoveArray[i]?.btId,
              containerId: doorForMoveArray[i]?.outsideCarrierContainer_id,
              containerBtId: doorForMoveArray[i]?.containerBtId,
              isTrailer: doorForMoveArray[i].btId != null ? true : false,
              isContainer:
                doorForMoveArray[i].containerBtId != null ? true : false,
            });
            dataTo.push({
              label:
                doorForMoveArray[i].doorType +
                "_" +
                doorForMoveArray[i].number +
                "_" +
                (doorForMoveArray[i].btId != null
                  ? doorForMoveArray[i].btId
                  : doorForMoveArray[i].containerBtId != null
                  ? doorForMoveArray[i].containerBtId
                  : "EMPTY"),
              value: doorForMoveArray[i].door_id,
              isdisabled:
                doorForMoveArray[i].btId != null ||
                doorForMoveArray[i].containerBtId != null
                  ? true
                  : false,
            });
          }
          setdoorFromArray(dataFrom);
          setdoorToArray(dataTo);
          if (props.rowDataUser?.doorFromId != null) {
            data = [];
            for (var i = 0; i < doorForMoveArray.length; i++) {
              if (
                doorForMoveArray[i].door_id == props.rowDataUser?.doorFromId
              ) {
                data.push({
                  label:
                    doorForMoveArray[i].doorType +
                    "_" +
                    doorForMoveArray[i].number +
                    "_" +
                    (doorForMoveArray[i].btId != null
                      ? doorForMoveArray[i].btId
                      : doorForMoveArray[i].containerBtId != null
                      ? doorForMoveArray[i].containerBtId
                      : "EMPTY"),
                  value: doorForMoveArray[i].door_id,
                  isdisabled: false,
                });
              }
            }
            setDoorFrom({
              value: data[0].value,
              label: data[0].label,
              isdisabled: data[0].isdisabled,
            });
          }
          if (props.rowDataUser?.doorToId != null) {
            data = [];
            for (var i = 0; i < doorForMoveArray.length; i++) {
              if (doorForMoveArray[i].door_id == props.rowDataUser?.doorToId) {
                data.push({
                  label:
                    doorForMoveArray[i].doorType +
                    "_" +
                    doorForMoveArray[i].number +
                    "_" +
                    (doorForMoveArray[i].btId &&
                    doorForMoveArray[i].btId != null
                      ? doorForMoveArray[i].btId
                      : "EMPTY˝"),
                  value: doorForMoveArray[i].door_id,
                  isdisabled: false,
                });
              }
            }
            setDoorTo({
              value: data[0].value,
              label: data[0].label,
              isdisabled: data[0].isdisabled,
            });
          }
        }
      }
    }

    if (
      props.rowDataUser?.outsideCarrierContainer_id != null ||
      props.rowDataUser?.outsideCarrierContainer_id != ""
    ) {
      let obj = {
        pageNo: 1,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_CALL,
        payload: { value: obj },
      });
    }

    if (
      props.rowDataUser?.lotFromId != null &&
      props.rowDataUser?.lotFrom != null
    ) {
      setLotFrom({
        value: props.rowDataUser?.lotFrom?.lot_id,
        label: props.rowDataUser?.lotFrom?.lotName,
      });
    }

    if (
      props.rowDataUser?.spaceFromId != null &&
      props.rowDataUser?.spaceFrom != null
    ) {
      setSpaceFrom({
        value: props.rowDataUser?.spaceFrom?.space_id,
        label: props.rowDataUser?.lotFrom?.btId,
      });
    }

    if (
      props.rowDataUser?.lotToId != null &&
      props.rowDataUser?.lotTo != null
    ) {
      setLotTo({
        value: props.rowDataUser?.lotTo?.lot_id,
        label: props.rowDataUser?.lotTo?.lotName,
      });
    }

    if (
      props.rowDataUser?.divisionToId != null &&
      props.rowDataUser?.divisionTo != null
    ) {
      setDivisionTo({
        value: props.rowDataUser?.divisionTo?.division_id,
        label: props.rowDataUser?.divisionTo?.divisionName,
      });
    }

    if (
      props.rowDataUser?.department &&
      props.rowDataUser?.department != "" &&
      props.rowDataUser?.department != null
    ) {
      let department = rowDataDepartmentTemp.filter(
        (item) => item.departmentName == props.rowDataUser.department
      );
      setDepartmentType({
        value: department[0]?.departmentName,
        label: department[0]?.departmentName,
      });
      setDepartment({
        value: department[0]?.departmentName,
        label: department[0]?.departmentName,
      });
    }
  }, []);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    dispatch({
      type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT
        .GET_TRAILER_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    if (containerArray && containerArray.length > 0) {
      var data = [];
      for (var i = 0; i < containerArray.length; i++) {
        data.push({
          label: containerArray[i].btId,
          value: containerArray[i]?.outsideCarrierContainer_id,
        });
      }

      if (
        props.rowDataUser?.outsideCarrierContainer_id != null &&
        props.rowDataUser?.outsideCarrierContainer_id != ""
      ) {
        setIsContainer(true);
        setIsTrailer(false);
        setContainerId({
          label: props.rowDataUser?.outsideCarrierContainer?.btId,
          value:
            props.rowDataUser?.outsideCarrierContainer
              ?.outsideCarrierContainer_id,
        });
      }
      setContainerIdArray(data);
      setCreateContainerEnable(false);
    }
  }, [containerArray]);

  useEffect(() => {
    if (containerId?.value !== "" && containerArray?.length == 0) {
      setPage(0);
      setCreateContainerEnable(true);
      setContainerIdArray([]);
    } else if (containerArray && containerArray.length > 0) {
      var data = [];
      for (var i = 0; i < containerArray.length; i++) {
        data.push({
          label: containerArray[i]?.btId,
          value: containerArray[i]?.outsideCarrierContainer_id,
        });
      }

      setContainerIdArray(data);
      setCreateContainerEnable(false);
    }
  }, [containerIdArray, containerId]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_DOOR_FOR_MOVES_API_CALL,
    });
  }, [division != "null" && division != ""]);

  useEffect(() => {
    if (rowContainerData && rowContainerData != "Failed") {
      setContainerId({
        value: rowContainerData?.outsideCarrierContainer_id,
        label: rowContainerData?.btId,
      });
    }
  }, [rowContainerData]);

  useEffect(() => {
    if (moveType?.value == "SPACE2SPACE") {
      var rowDataLotTemp = rowDataLot?.filter(
        (item) => item.division_id == division?.value
      );

      if (rowDataLotTemp.length > 0) {
        let data = [];
        for (var i = 0; i < rowDataLotTemp?.length; i++) {
          data.push({
            label: rowDataLotTemp[i].lotName,
            value: rowDataLotTemp[i].lot_id,
            spaces: rowDataLotTemp[i].spaces,
            division_id: rowDataLotTemp[i].division_id,
            divisionName: rowDataLotTemp[i].divisionName,
          });
        }
        setLotFromArray(data);
      }
      if (
        props.rowDataUser?.spaceFromId != null &&
        props.rowDataUser?.spaceFrom != null
      ) {
        setSpaceFrom({
          label: props.rowDataUser?.spaceFrom?.btId + "_" + "EMPTY",
          value: props.rowDataUser?.spaceFrom.space_id,
        });
      }
    } else if (
      moveType?.value == "DOORIN" ||
      moveType?.value == "DOOROUT" ||
      moveType?.value == "RESET" ||
      moveType?.value == "DOOR2DOOR"
    ) {
      if (
        rowDataDoorForMove &&
        rowDataDoorForMove?.length > 0 &&
        rowDataDoorForMove != "Failed"
      ) {
        var data = [];
        let doorForMoveArray = rowDataDoorForMove?.filter(
          (item) => item.division_id == divisionSelectedTemp?.value
        );
        for (var i = 0; i < doorForMoveArray.length; i++) {
          let trailerValue =
            doorForMoveArray[i].currentOccupancy != null
              ? "TRAILER"
              : doorForMoveArray[i].outsideCarrierContainer_id != null
              ? "CONTAINER"
              : "EMPTY";
          if (
            moveType?.value == "DOOROUT" ||
            moveType?.value == "RESET" ||
            moveType?.value == "DOOR2DOOR"
          ) {
            data.push({
              label:
                doorForMoveArray[i].doorType +
                "_" +
                doorForMoveArray[i].number +
                "_" +
                (doorForMoveArray[i].btId != null
                  ? doorForMoveArray[i].btId
                  : doorForMoveArray[i].containerBtId != null
                  ? doorForMoveArray[i].containerBtId
                  : "EMPTY"),
              value: doorForMoveArray[i].door_id,
              trailerId: doorForMoveArray[i].btId,
              isdisabled:
                doorForMoveArray[i].btId == null &&
                doorForMoveArray[i].containerBtId == null
                  ? true
                  : false,
              containerId: doorForMoveArray[i]?.outsideCarrierContainer_id,
              containerBtId: doorForMoveArray[i]?.containerBtId,
              isTrailer: doorForMoveArray[i].btId != null ? true : false,
              isContainer:
                doorForMoveArray[i].containerBtId != null ? true : false,
            });
            setdoorFromArray(data);
          } else {
            data.push({
              label:
                doorForMoveArray[i].doorType +
                "_" +
                doorForMoveArray[i].number +
                "_" +
                (doorForMoveArray[i].btId
                  ? doorForMoveArray[i].btId
                  : doorForMoveArray[i].containerBtId != null
                  ? doorForMoveArray[i].containerBtId
                  : "EMPTY"),
              value: doorForMoveArray[i].door_id
                ? doorForMoveArray[i].door_id
                : "EMPTY",
              isdisabled:
                doorForMoveArray[i].btId != null ||
                doorForMoveArray[i].containerBtId != null
                  ? true
                  : false,
            });
            setdoorToArray(data);
          }
        }
        if (moveType?.value === "DOOR2DOOR") {
          if (
            rowDataDoorForMove &&
            rowDataDoorForMove.length > 0 &&
            rowDataDoorForMove != "Failed"
          ) {
            var dataFrom = [],
              dataTo = [],
              data = [];
            let doorForMoveArray = rowDataDoorForMove.filter(
              (item) => item.division_id == divisionSelectedTemp?.value
            );
            for (var i = 0; i < doorForMoveArray.length; i++) {
              let trailerValue =
                doorForMoveArray[i].currentOccupancy != null
                  ? "_TRAILER"
                  : doorForMoveArray[i]?.outsideCarrierContainer_id != null
                  ? "_CONTAINER"
                  : "_EMPTY";
              dataFrom.push({
                label:
                  doorForMoveArray[i].doorType +
                  "_" +
                  doorForMoveArray[i].number +
                  "_" +
                  (doorForMoveArray[i].btId != null
                    ? doorForMoveArray[i].btId
                    : doorForMoveArray[i].containerBtId != null
                    ? doorForMoveArray[i].containerBtId
                    : "EMPTY"),
                value: doorForMoveArray[i].door_id,
                isdisabled:
                  doorForMoveArray[i].btId == null &&
                  doorForMoveArray[i].containerBtId == null
                    ? true
                    : false,
                trailerId: doorForMoveArray[i].btId,
                containerId: doorForMoveArray[i].outsideCarrierContainer_id,
                containerBtId: doorForMoveArray[i].containerBtId,
                isTrailer: doorForMoveArray[i].btId != null ? true : false,
                isContainer:
                  doorForMoveArray[i].containerBtId != null ? true : false,
              });
              dataTo.push({
                label:
                  doorForMoveArray[i].doorType +
                  "_" +
                  doorForMoveArray[i].number +
                  "_" +
                  (doorForMoveArray[i].btId != null
                    ? doorForMoveArray[i].btId
                    : doorForMoveArray[i].containerBtId != null
                    ? doorForMoveArray[i].containerBtId
                    : "EMPTY"),
                value: doorForMoveArray[i].door_id,
                isdisabled:
                  doorForMoveArray[i].btId != null ||
                  doorForMoveArray[i].containerBtId != null
                    ? true
                    : false,
              });
            }
            setdoorFromArray(dataFrom);
            setdoorToArray(dataTo);
            if (props.rowDataUser?.doorFromId != null) {
              data = [];
              for (var i = 0; i < doorForMoveArray.length; i++) {
                if (
                  doorForMoveArray[i].door_id == props.rowDataUser?.doorFromId
                ) {
                  data.push({
                    label:
                      doorForMoveArray[i].doorType +
                      "_" +
                      doorForMoveArray[i].number +
                      "_" +
                      (doorForMoveArray[i].btId != null
                        ? doorForMoveArray[i].btId
                        : doorForMoveArray[i].containerBtId != null
                        ? doorForMoveArray[i].containerBtId
                        : "EMPTY"),
                    value: doorForMoveArray[i].door_id,
                    isdisabled: false,
                  });
                }
              }

              setDoorFrom({
                value: data[0].value,
                label: data[0].label,
                isdisabled: data[0].isdisabled,
              });
            }
            if (props.rowDataUser?.doorToId != null) {
              data = [];
              for (var i = 0; i < doorForMoveArray.length; i++) {
                if (
                  doorForMoveArray[i].door_id == props.rowDataUser?.doorToId
                ) {
                  data.push({
                    label:
                      doorForMoveArray[i].doorType +
                      "_" +
                      doorForMoveArray[i].number +
                      "_" +
                      (doorForMoveArray[i].btId &&
                      doorForMoveArray[i].btId != null
                        ? doorForMoveArray[i].btId
                        : "EMPTY"),
                    value: doorForMoveArray[i].door_id,
                    isdisabled: false,
                  });
                }
              }
              setDoorTo({
                value: data[0].value,
                label: data[0].label,
                isdisabled: data[0].isdisabled,
              });
            }
          }
        }
      }

      var lotArr = rowDataLot?.filter(
        (item) => item.division_id == division?.division_id
      );

      if (lotArr.length > 0) {
        let data = [];
        for (var i = 0; i < lotArr.length; i++) {
          data.push({
            label: lotArr[i].lotName,
            value: lotArr[i].lot_id,
            spaces: lotArr[i].spaces,
          });
        }
        //Lot From Id & Lot To Id
        if (props.rowDataUser?.lotFromId != null && divisionArr.length > 0) {
          var lotFromIdTemp = data.filter(
            (item) => item.value == props.rowDataUser?.lotFromId
          );
          setLotFrom({
            value: lotFromIdTemp[0].value,
            label: lotFromIdTemp[0].label,
          });
        }
        setLotFromArray(data);

        if (props.rowDataUser?.lotToId != null && divisionArr.length > 0) {
          var lotToIdTemp = data.filter(
            (item) => item.value == props.rowDataUser?.lotToId
          );
          setLotTo({
            value: lotToIdTemp[0].value,
            label: lotToIdTemp[0].label,
          });
        }
        setLotToArray(data);
      } else {
        let obj = {
          division_id: divisionSelectedTemp?.value,
        };
        dispatch({
          type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
            .GET_LOTS_BY_DIVISION_MANAGEMENT_API_CALL,
          payload: { value: obj },
        });
      }
    } else if (moveType?.value == "YARD2YARD") {
      if (rowDataLot?.length > 0) {
        if (props.rowDataUser?.lotToId != null) {
          //get lot
          let lotArray = rowDataLot?.filter(
            (item) => item.lot_id == props.rowDataUser.lotToId
          );
          setLotTo({
            label: lotArray[0].lotName,
            value: lotArray[0].lot_id,
            spaces: lotArray[0].spaces,
            division_id: lotArray[0].division_id,
            divisionName: lotArray[0].divisionName,
          });

          let lotDivisionArray = rowDataLot?.filter(
            (item) => item.division_id == division?.value
          );

          let data = [];
          for (var i = 0; i < lotDivisionArray.length; i++) {
            if (props.rowDataUser?.lotFromId != null) {
              if (lotDivisionArray[i].lot_id == props.rowDataUser?.lotFromId) {
                data.push({
                  label: lotDivisionArray[i].lotName,
                  value: lotDivisionArray[i].lot_id,
                  spaces: lotDivisionArray[i].spaces,
                  division_id: lotDivisionArray[i].division_id,
                  divisionName: lotDivisionArray[i].divisionName,
                  isdisabled: true,
                });
              } else {
                data.push({
                  label: lotDivisionArray[i].lotName,
                  value: lotDivisionArray[i].lot_id,
                  spaces: lotDivisionArray[i].spaces,
                  division_id: lotDivisionArray[i].division_id,
                  divisionName: lotDivisionArray[i].divisionName,
                });
              }
            } else {
              data.push({
                label: lotDivisionArray[i].lotName,
                value: lotDivisionArray[i].lot_id,
                spaces: lotDivisionArray[i].spaces,
                division_id: lotDivisionArray[i].division_id,
                divisionName: lotDivisionArray[i].divisionName,
              });
            }
          }
          setLotToArray(data);
        }
        if (props.rowDataUser?.lotFromId != null) {
          //get lot
          let lotArray = rowDataLot?.filter(
            (item) => item.lot_id == props.rowDataUser.lotFromId
          );
          setLotFrom({
            label: lotArray[0].lotName,
            value: lotArray[0].lot_id,
            spaces: lotArray[0].spaces,
            division_id: lotArray[0].division_id,
            divisionName: lotArray[0].division.divisionName,
          });

          let lotDivisionArray = rowDataLot?.filter(
            (item) => item.division_id == division?.value
          );

          let data = [];
          for (var i = 0; i < lotDivisionArray.length; i++) {
            data.push({
              label: lotDivisionArray[i].lotName,
              value: lotDivisionArray[i].lot_id,
              spaces: lotDivisionArray[i].spaces,
              division_id: lotDivisionArray[i].division_id,
              divisionName: lotDivisionArray[i].divisionName,
            });
          }
          setYardFromArr(data);
        } else {
          let data = [];
          let rowDataLotTemp = rowDataLot?.filter(
            (item) => item.division_id == division?.value
          );
          for (var i = 0; i < rowDataLotTemp?.length; i++) {
            data.push({
              label: rowDataLotTemp[i].lotName,
              value: rowDataLotTemp[i].lot_id,
              spaces: rowDataLotTemp[i].spaces,
              division_id: rowDataLotTemp[i].division_id,
              divisionName: rowDataLotTemp[i].divisionName,
            });
          }
          setLotToArray(data);
          setYardFromArr(data);
        }
      }
    }
  }, [moveType && moveType?.value]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_TO_API_CALL,
    });

    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_FROM_API_CALL,
    });
  }, [moveType && moveType?.value == "SPACE2SPACE"]);

  useEffect(() => {
    if (props.rowDataUser?.trailer && props.rowDataUser?.trailer != null) {
      if (props.rowDataUser?.doorFrom && props.rowDataUser?.doorFrom?.door_id) {
        setCurrentLocation(
          props.rowDataUser?.division?.divisionName +
            "_" +
            props.rowDataUser?.doorFrom?.doorType +
            "_" +
            props.rowDataUser?.doorFrom?.number
        );
      } else if (
        props.rowDataUser?.spaceFrom &&
        props.rowDataUser?.spaceFrom?.space_id
      ) {
        setCurrentLocation(
          props.rowDataUser?.division?.divisionName +
            "_" +
            props.rowDataUser?.spaceFrom?.btId +
            (props.rowDataUser?.spaceFrom?.lotName !== null &&
            props.rowDataUser?.spaceFrom?.lot?.lotName !== undefined
              ? "_" + props.rowDataUser?.spaceFrom?.lot?.lotName
              : "")
        );
      } else {
        setCurrentLocation(
          props.rowDataUser?.division?.divisionName +
            "_" +
            (props.rowDataUser?.currentLocation || "UNKNOWN")
        );
      }
    } else if (
      trailerId !== null &&
      trailerId !== "" &&
      rowDataRuralLog?.length > 0
    ) {
      var sortedDoorLog = rowDataRuralLog.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      if (sortedDoorLog.length > 0) {
        let spaceOccupant = sortedDoorLog[0].currDoor?.door_id
          ? sortedDoorLog[0].currDoor.doorType +
            "_" +
            sortedDoorLog[0].currDoor.number
          : sortedDoorLog[0]?.currSpace && sortedDoorLog[0].currSpace.btId
          ? sortedDoorLog[0].currSpace.lot?.lotName +
            "_" +
            sortedDoorLog[0].currSpace.btId
          : sortedDoorLog[0]?.currentLocation
          ? sortedDoorLog[0].currentLocation
          : "UNKNOWN";
        setCurrentLocation(
          (division?.label ? division.label + "_" : "") +
            (spaceOccupant || "UNKNOWN")
        );
        if (
          sortedDoorLog[0]?.currSpace &&
          sortedDoorLog[0]?.currSpace?.btId &&
          moveType?.value == "DOORIN"
        ) {
          setSpaceFrom({
            label:
              sortedDoorLog[0].currSpace.lot?.lotName +
              "_" +
              sortedDoorLog[0].currSpace?.btId,
            value: sortedDoorLog[0].currSpace?.space_id,
          });
        } else if (
          sortedDoorLog[0]?.currDoor &&
          sortedDoorLog[0]?.currDoor?.door_id !== null &&
          moveType?.value == "DOORIN"
        ) {
          setDoorFrom({
            label:
              sortedDoorLog[0]?.currDoor?.doorType +
              "_" +
              sortedDoorLog[0]?.currDoor?.number,
            value: sortedDoorLog[0]?.currDoor?.door_id,
          });
        } else if (moveType?.value == "DOORIN") {
          setLocationFrom({
            label:
              sortedDoorLog[0]?.currentLocation != null
                ? sortedDoorLog[0]?.currentLocation
                : "UNKNOWN",
            value:
              sortedDoorLog[0]?.currentLocation != null
                ? sortedDoorLog[0]?.currentLocation
                : "UNKNOWN",
          });
        }
      }
    }
  }, [rowDataRuralLog]);

  useEffect(() => {
    if (rowSpaceFromArray?.length > 0) {
      let spaceFromArrTemp = rowSpaceFromArray?.filter(
        (item) => item.lot_id == lotFrom?.value
      );
      if (spaceFromArrTemp.length > 0) {
        let data = [];
        for (var i = 0; i < spaceFromArrTemp.length; i++) {
          data.push({
            label:
              spaceFromArrTemp[i].btId +
              "_" +
              (spaceFromArrTemp[i]?.trailerBtId
                ? spaceFromArrTemp[i]?.trailerBtId
                : "EMPTY"),
            value: spaceFromArrTemp[i].space_id,
            trailerBtId: spaceFromArrTemp[i]?.trailerBtId
              ? spaceFromArrTemp[i]?.trailerBtId
              : "",
            trailerId: spaceFromArrTemp[i]?.trailer_id
              ? spaceFromArrTemp[i]?.trailer_id
              : null,
          });
        }
        if (
          props.rowDataUser?.spaceFromId != null &&
          props.rowDataUser?.spaceFrom != null
        ) {
          let spaceFromTemp = spaceFromArrTemp.filter(
            (item) => item.space_id == props.rowDataUser?.spaceFrom?.space_id
          );
          if (spaceFromTemp && spaceFromTemp.length > 0)
            setSpaceFrom({
              label:
                spaceFromTemp[0]?.btId +
                "_" +
                (spaceFromTemp[0]?.trailerBtId
                  ? spaceFromTemp[0]?.trailerBtId
                  : "EMPTY"),
              value: spaceFromTemp[0]?.space_id,
              trailerBtId: spaceFromTemp[0]?.trailerBtId
                ? spaceFromTemp[0]?.trailerBtId
                : "",
              trailerId: spaceFromTemp[0]?.trailer_id
                ? spaceFromTemp[0]?.trailer_id
                : null,
            });
        }
        setSpaceFromArray(data);
      }
    }
  }, [rowSpaceFromArray]);

  useEffect(() => {
    if (rowSpaceToArray && rowSpaceToArray.length > 0) {
      let spaceToArrTemp = rowSpaceToArray.filter(
        (item) => item.lot_id == lotTo?.value
      );
      if (spaceToArrTemp.length > 0) {
        let data = [];
        for (var i = 0; i < spaceToArrTemp.length; i++) {
          data.push({
            label:
              spaceToArrTemp[i]?.btId +
              "_" +
              (spaceToArrTemp[i]?.trailerBtId
                ? spaceToArrTemp[i]?.trailerBtId
                : "EMPTY"),
            value: spaceToArrTemp[i].space_id,
            trailerBtId: spaceToArrTemp[i]?.trailerBtId
              ? spaceToArrTemp[i]?.trailerBtId
              : "",
            trailerId: spaceToArrTemp[i]?.trailer_id
              ? spaceToArrTemp[i]?.trailer_id
              : null,
          });
        }
        if (
          props.rowDataUser?.spaceToId != null &&
          props.rowDataUser?.spaceTo != null
        ) {
          let spaceToTemp = spaceToArrTemp.filter(
            (item) => item.space_id == props.rowDataUser?.spaceTo?.space_id
          );
          if (spaceToTemp.length == 0) {
            setSpaceTo({
              label: props.rowDataUser.spaceTo?.btId + "_" + "EMPTY",
              value: props.rowDataUser.spaceTo?.space_id,
              trailerBtId: "",
              trailerId: null,
              isDisabled: true,
            });
            if (moveType?.value == "DC2YARD") {
              setSpaceDC2SpaceValue({
                label: props.rowDataUser.spaceTo?.btId + "_" + "EMPTY",
                value: props.rowDataUser.spaceTo?.space_id,
                trailerBtId: "",
                trailerId: null,
                isDisabled: true,
              });
            }
          } else {
            setSpaceTo({
              label:
                spaceToTemp[0]?.btId +
                "_" +
                (spaceToTemp[0]?.trailerBtId
                  ? spaceToTemp[0]?.trailerBtId
                  : "EMPTY"),
              value: spaceToTemp[0]?.space_id,
              trailerBtId: spaceToTemp[0]?.trailerBtId
                ? spaceToTemp[0]?.trailerBtId
                : "",
              trailerId: spaceToTemp[0]?.trailer_id
                ? spaceToTemp[0]?.trailer_id
                : null,
            });
            if (moveType?.value == "DC2YARD") {
              setSpaceDC2SpaceValue({
                label:
                  spaceToTemp[0]?.btId +
                  "_" +
                  (spaceToTemp[0]?.trailerBtId
                    ? spaceToTemp[0]?.trailerBtId
                    : "EMPTY"),
                value: spaceToTemp[0]?.space_id,
                trailerBtId: spaceToTemp[0]?.trailerBtId
                  ? spaceToTemp[0]?.trailerBtId
                  : "",
                trailerId: spaceToTemp[0]?.trailer_id
                  ? spaceToTemp[0]?.trailer_id
                  : null,
              });
            }
          }
        }
        setSpaceToArray(data);
      }
    }
  }, [rowSpaceToArray]);

  const callSomeApi = async (newTextValue) => {
    let tempPageNo = pageNo;
    if (newTextValue != "" && newTextValue?.value != "") {
      let obj = {
        pageNo: ++tempPageNo,
        searchText: newTextValue,
      };
      setPage(obj?.pageNo);
      dispatch({
        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_CALL,
        payload: { value: obj },
      });
    }
  };

  const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    return strTime;
  };

  function dateDiffCalc(milliseconds) {
    let secs = Math.floor(Math.abs(milliseconds) / 1000);
    let mins = Math.floor(secs / 60);
    let hours = Math.floor(mins / 60);
    const millisecs = Math.floor(Math.abs(milliseconds)) % 1000;

    return {
      days: hours + " ",
      hours: " :" + (hours % 24) + " ,",
      minutes: " :" + (mins % 60) + " ,",
      seconds: " " + (secs % 60) + " ",
      milliSeconds: " " + millisecs + " ",
    };
  }

  useEffect(() => {
    let myDate = requestTime ? new Date(requestTime) : new Date();
    let dateTimeFormat =
      myDate.getMonth() +
      1 +
      "/" +
      myDate.getDate() +
      "/" +
      myDate.getFullYear() +
      " " +
      formatAMPM(myDate);
    setRequestTime(dateTimeFormat);
  }, []);

  const filterOptions = (inputValue) => {
    return containerIdArray?.filter((i) =>
      i.label?.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  return (
    <Modal
      size="lg"
      show={props.isShow}
      onHide={props.handleClose}
      backdrop="static"
      centered
      keyboard={false}
    >
      <Modal.Header style={{ backgroundColor: "rgb(0, 42, 74)" }}>
        <Modal.Title style={{ fontFamily: "Roboto", color: "white" }}>
          {props.title ? props.title : "Create New Move"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
            <div>
              <label style={{ fontSize: 14 }}>
                {props.keyData == "InProgressRequest"
                  ? "Request Start Time"
                  : "Request Time"}
              </label>
            </div>

            <DateTimePicker
              className="dateTimePicker"
              value={requestTime}
              disabled={true}
            />

            {/* </div> */}
          </div>

          <div className="col-12 col-md-12 col-sm-12 col-lg-1 mb-2" />
          {props.keyData == "InProgressRequest" ? (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
              <div>
                <label style={{ fontSize: 14 }}>{"Request Finish Time"}</label>
              </div>

              <div>
                <DateTimePicker
                  className="d-flex"
                  value={requestFinishTime}
                  onChange={(requestFinishTime) => {
                    setTotalTime();
                    let myDate = new Date(requestFinishTime);
                    setRequestFinishTime(requestFinishTime);
                    let milliSeconds =
                      myDate - new Date(props.rowDataUser?.startDateTime);
                    let totalTime = dateDiffCalc(milliSeconds);
                    setTotalTime(totalTime);
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
              <div>
                <label style={{ fontSize: 14 }}>Requester Name</label>
              </div>

              <div>
                <DropDownComp
                  style={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Requester"}
                  options={activeUsers}
                  onChange={(value) => {
                    setRequesterName(value);
                    let obj = {
                      pageNo: 1,
                    };
                    dispatch({
                      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                        .GET_CONTAINERS_API_CALL,
                      payload: { value: obj },
                    });
                  }}
                  value={requesterName != undefined ? requesterName : ""}
                />
              </div>
            </div>
          )}
        </div>

        {moveType && moveType?.value == "Off Site" ? null : (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            {props.title != "Create New Move" ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Total Time</label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      height: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "8px",
                      fontSize: 14,
                    }}
                    labelName={"Total Time"}
                    maxLength={30}
                    placeholder={"Total Time"}
                    value={
                      totalTime
                        ? totalTime?.days +
                          "hours" +
                          totalTime?.minutes +
                          "minutes"
                        : ""
                    }
                    isDisabled={true}
                  />
                </div>
              </div>
            ) : null}

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Move Type"}</label>
              </div>
              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Move Type"}
                  options={moveTypeArr}
                  isDisabled={props.title == "Create New Move" ? false : true}
                  onChange={(value) => {
                    setMoveType(value);
                    setDoorTo("");
                    setDepartment("");
                    setLotTo("");
                    setSpaceTo("");
                    setLotFrom("");
                    setSpaceFrom("");
                    setDoorFrom("");
                    setTrailerId("");
                    setCurrentLocation("");
                    setContainerId("");
                    if (
                      value?.value == "SPACE2SPACE" ||
                      value?.value == "DOOROUT"
                    ) {
                      dispatch({
                        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                          .GET_LOTS_MANAGEMENT_API_CALL,
                      });
                    }
                    dispatch({
                      type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
                        .GET_DIVISIONS_MANAGEMENT_API_CALL,
                    });
                  }}
                  value={moveType}
                />
              </div>
            </div>

            {moveType &&
            (moveType?.value == "DOOROUT" ||
              moveType?.value == "DOORIN" ||
              moveType?.value == "RESET") ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
                <div>
                  <label style={{ fontSize: 14 }}>
                    {" "}
                    {moveType &&
                    (moveType?.value == "DOOROUT" || moveType?.value == "RESET")
                      ? "Door From"
                      : "Door To"}
                  </label>
                </div>

                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Door"}
                    isDisabled={
                      props.keyData == "InProgressRequest" ? true : false
                    }
                    options={
                      moveType &&
                      (moveType?.value == "DOOROUT" ||
                        moveType?.value == "RESET")
                        ? doorFromArray
                        : doorToArray
                    }
                    onChange={(value) => {
                      setContainerId("");
                      setTrailerId("");
                      if (
                        moveType &&
                        (moveType?.value == "DOOROUT" ||
                          moveType?.value == "RESET")
                      ) {
                        setDoorFrom(value);
                        if (rowDataTrailer && rowDataTrailer.length > 0) {
                          if (value?.isTrailer && value.trailerId != null) {
                            setIsTrailer(true);
                            setIsContainer(false);
                            let trailerId = rowDataTrailer.filter(
                              (item) => item.btId == value.trailerId
                            );
                            if (trailerId != null) {
                              setTrailerId({
                                label: trailerId[0].btId,
                                value: trailerId[0].id,
                              });
                            }
                            let obj = {
                              id:
                                trailerId[0]?.id != undefined
                                  ? trailerId[0].id
                                  : 0,
                            };
                            dispatch({
                              type: CONSTANTS
                                .CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                                .GET_RURAL_TRAILER_LOGS_API_CALL,
                              payload: { value: obj },
                            });
                          } else if (
                            value?.isContainer &&
                            value.containerId != null
                          ) {
                            setIsTrailer(false);
                            setIsContainer(true);
                            setContainerId({
                              value: value?.containerId,
                              label: value?.containerBtId,
                            });
                          } else {
                            setIsTrailer(true);
                            setIsContainer(false);
                          }
                        }
                      } else {
                        setDoorTo(value);
                      }
                    }}
                    value={
                      moveType &&
                      (moveType?.value == "DOOROUT" ||
                        moveType?.value == "RESET")
                        ? doorFrom
                        : doorTo
                    }
                  />
                </div>
              </div>
            ) : moveType && moveType?.value == "DOOR2DOOR" ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
                <div>
                  <label style={{ fontSize: 14 }}> {"Door From"}</label>
                </div>

                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Door From"}
                    isDisabled={false}
                    options={doorFromArray}
                    onChange={(value) => {
                      setDoorFrom(value);
                      setDoorTo("");
                      setContainerId("");
                      setTrailerId("");
                      if (value?.isTrailer && value.trailerId != null) {
                        setIsTrailer(true);
                        setIsContainer(false);
                        let trailerId = rowDataTrailer.filter(
                          (item) => item.btId == value.trailerId
                        );
                        if (trailerId != null) {
                          setTrailerId({
                            label: trailerId[0].btId,
                            value: trailerId[0].id,
                          });
                        }
                        let obj = {
                          id:
                            trailerId[0]?.id != undefined ? trailerId[0].id : 0,
                        };
                        dispatch({
                          type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                            .GET_RURAL_TRAILER_LOGS_API_CALL,
                          payload: { value: obj },
                        });
                      } else if (
                        value?.isContainer &&
                        value.containerId != null
                      ) {
                        setIsTrailer(false);
                        setIsContainer(true);
                        setContainerId({
                          value: value?.containerId,
                          label: value?.containerBtId,
                        });
                      } else {
                        setIsTrailer(true);
                        setIsContainer(false);
                      }
                    }}
                    value={doorFrom}
                  />
                </div>
              </div>
            ) : moveType && moveType?.value == "SPACE2SPACE" ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
                <div>
                  <label style={{ fontSize: 14 }}> {"Yard From"}</label>
                </div>

                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Yard From"}
                    options={lotFromArr}
                    onChange={(value) => {
                      setLotFrom(value);
                      setSpaceFrom("");
                      setSpaceFromArray([]);
                      if (rowSpaceFromArray.length > 0) {
                        let spaceFromArrTemp = rowSpaceFromArray.filter(
                          (item) => item.lot_id == value.value
                        );
                        if (spaceFromArrTemp.length > 0) {
                          let data = [];
                          for (var i = 0; i < spaceFromArrTemp.length; i++) {
                            data.push({
                              label:
                                spaceFromArrTemp[i].btId +
                                "_" +
                                (spaceFromArrTemp[i]?.trailerBtId
                                  ? spaceFromArrTemp[i]?.trailerBtId
                                  : "EMPTY"),
                              value: spaceFromArrTemp[i].space_id,
                              trailerBtId: spaceFromArrTemp[i]?.trailerBtId
                                ? spaceFromArrTemp[i]?.trailerBtId
                                : "",
                              trailerId: spaceFromArrTemp[i]?.trailer_id
                                ? spaceFromArrTemp[i]?.trailer_id
                                : null,
                            });
                          }
                          setSpaceFromArray(data);
                        }
                      }
                    }}
                    value={lotFrom}
                  />
                </div>
              </div>
            ) : null}

            {moveType && moveType?.value == "DOOR2DOOR" && doorFrom != "" ? (
              <div
                className="row container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "space-between",
                }}
              >
                <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
                  <div>
                    <label style={{ fontSize: 14 }}> {"Door To"}</label>
                  </div>

                  <div>
                    <DropDownComp
                      styles={{
                        height: 35,
                        display: "flex",
                        flexDirection: "row",

                        borderColor: "hsl(0, 0%, 50%)",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        fontSize: 14,
                      }}
                      name={"Select Door To"}
                      isDisabled={false}
                      options={doorToArray}
                      onChange={(value) => {
                        setDoorTo(value);
                      }}
                      value={doorTo}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {moveType && moveType?.value == "YARD2YARD" ? null : moveType &&
              moveType?.value == "SPACE2SPACE" &&
              lotFrom != "" ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
                <div>
                  <label style={{ fontSize: 14 }}>Space From</label>
                </div>

                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Space From"}
                    options={spaceFromArr}
                    onChange={(value) => {
                      setSpaceFrom(value);
                      setTrailerId({
                        value: value?.trailerId,
                        label: value?.trailerBtId,
                      });
                      setIsTrailer(true);
                      let obj = {
                        id: value?.trailerId ? value.trailerId : 0,
                      };
                      dispatch({
                        type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                          .GET_RURAL_TRAILER_LOGS_API_CALL,
                        payload: { value: obj },
                      });
                    }}
                    value={spaceFrom}
                  />
                </div>
              </div>
            ) : props.keyData == "InProgressRequest" ? null : division !=
                null && division != "" ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
                <div>
                  <label style={{ fontSize: 14 }}>{"Department"} </label>
                </div>
                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Department"}
                    options={departmentTypeArr}
                    onChange={(value) => {
                      setDepartment(value);

                      let obj = {
                        pageNo: 1,
                      };
                      dispatch({
                        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                          .GET_CONTAINERS_API_CALL,
                        payload: { value: obj },
                      });
                    }}
                    value={department}
                  />
                </div>
              </div>
            ) : null}
          </div>
        )}

        {moveType &&
        (moveType?.value == "DOOROUT" || moveType?.value == "SPACE2SPACE") ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Yard To"}</label>
              </div>
              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard To"}
                  options={lotToArr}
                  onChange={(value) => {
                    setLotTo(value);
                    setSpaceTo("");
                    setSpaceToArray([]);
                    if (rowSpaceToArray.length > 0) {
                      let spaceToArrTemp = rowSpaceToArray.filter(
                        (item) => item.lot_id == value?.value
                      );
                      if (spaceToArrTemp?.length > 0) {
                        let data = [];
                        for (var i = 0; i < spaceToArrTemp.length; i++) {
                          data.push({
                            label:
                              spaceToArrTemp[i].btId +
                              "_" +
                              (spaceToArrTemp[i]?.trailerBtId
                                ? spaceToArrTemp[i]?.trailerBtId
                                : "EMPTY"),
                            value: spaceToArrTemp[i].space_id,
                            trailerBtId: spaceToArrTemp[i]?.trailerBtId
                              ? spaceToArrTemp[i]?.trailerBtId
                              : "",
                            trailerId: spaceToArrTemp[i]?.trailer_id
                              ? spaceToArrTemp[i]?.trailer_id
                              : null,
                          });
                        }
                        setSpaceToArray(data);
                      }
                    }
                  }}
                  value={lotTo}
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>Space To</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Space To"}
                  options={spaceToArr}
                  onChange={(value) => {
                    setSpaceTo(value);
                  }}
                  value={spaceTo}
                />
              </div>
            </div>
            {moveType && moveType?.value == "SPACE2SPACE" ? (
              <div className="col-12 col-md-4 col-sm-12 col-lg-4 ">
                <div>
                  <label style={{ fontSize: 14 }}> {"Department"}</label>
                </div>

                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Department Type"}
                    options={departmentTypeArr}
                    onChange={(value) => {
                      setDepartmentType(value);
                      let obj = {
                        pageNo: 1,
                      };
                      dispatch({
                        type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                          .GET_CONTAINERS_API_CALL,
                        payload: { value: obj },
                      });
                    }}
                    value={departmentType}
                  />
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {moveType && moveType?.value == "DC2YARD" ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Move Type"}</label>
              </div>
              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Move Type"}
                  isDisabled={
                    props.keyData == "InProgressRequest" ? true : false
                  }
                  options={moveTypeArr}
                  onChange={(value) => {
                    setMoveType(value);
                    setDoorTo("");
                    setDepartment("");
                    setLotTo("");
                    setSpaceTo("");
                    setLotFrom("");
                    setSpaceFrom("");
                    if (value?.value == "SPACE2SPACE") {
                      dispatch({
                        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                          .GET_LOTS_MANAGEMENT_API_CALL,
                      });
                    }
                    if (value?.value == "Off Site") {
                      dispatch({
                        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
                          .GET_LOCATION_API_CALL,
                        payload: { value: { bydivision: true } },
                      });
                    }
                    dispatch({
                      type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
                        .GET_DIVISIONS_MANAGEMENT_API_CALL,
                    });
                  }}
                  value={moveType}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
              <div>
                <label style={{ fontSize: 14 }}>Trailer Id Search</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Trailer Id"}
                  options={trailerIdArray}
                  isDisabled={
                    props.keyData == "InProgressRequest" ? true : false
                  }
                  onChange={(value) => {
                    if (
                      (moveType?.value == "SPACE2SPACE" ||
                        moveType?.value == "DOOROUT" ||
                        (moveType?.value == "DOOR2DOOR" && doorFrom != null)) &&
                      trailerId?.value != "" &&
                      trailerId?.value != null
                    ) {
                      alert(
                        "Trailer already in space ,you cannot choose another trailer"
                      );
                    } else {
                      setTrailerId(value);
                      setCurrentLocation("");
                    }
                  }}
                  value={trailerId}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4">
              <div>
                <label style={{ fontSize: 14 }}>{"Division"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Division"}
                  isDisabled={
                    props.keyData == "InProgressRequest" ? true : false
                  }
                  options={divisionsArray}
                  onChange={(value) => {
                    setDivision(value);
                  }}
                  value={division}
                />
              </div>
            </div>
          </div>
        ) : null}

        {moveType && moveType?.value == "DC2YARD" ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Yard"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard"}
                  options={lotArray}
                  onChange={(value) => {
                    setLotTo(value);

                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                        .GET_SPACES_BY_LOTID_MANAGEMENT_API_CALL,
                      payload: { value: { lot_id: value?.value } },
                    });
                  }}
                  value={lotTo}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>Space</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Space From"}
                  options={spaceDC2SpaceArray}
                  onChange={(value) => {
                    setSpaceDC2SpaceValue(value);
                  }}
                  value={spaceDC2SpaceValue}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4">
              <div>
                <label style={{ fontSize: 14 }}>Driver</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Driver"}
                  options={driverTypeArr}
                  onChange={(value) => {
                    setDriver(value);
                  }}
                  isDisabled={false}
                  value={driver}
                />
              </div>
            </div>
          </div>
        ) : null}

        {moveType && moveType?.value == "YARD2YARD" ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Yard From"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard from"}
                  isDisabled={false}
                  options={YardFromArr}
                  onChange={(value) => {
                    setLotFrom(value);
                    setLotTo("");
                    setSpaceFrom("");
                    let data = [];
                    for (let i = 0; i < YardFromArr.length; i++) {
                      if (YardFromArr[i].value == value.value) {
                        data.push({
                          label: YardFromArr[i]?.label,
                          value: YardFromArr[i]?.value,
                          spaces: YardFromArr[i].spaces,
                          division_id: YardFromArr[i].division_id,
                          divisionName: YardFromArr[i]?.divisionName,
                          isdisabled: true,
                        });
                      } else {
                        data.push({
                          label: YardFromArr[i]?.label,
                          value: YardFromArr[i]?.value,
                          spaces: YardFromArr[i]?.spaces,
                          division_id: YardFromArr[i]?.division_id,
                          divisionName: YardFromArr[i]?.divisionName,
                          isdisabled: false,
                        });
                      }
                      setLotToArray(data);
                    }
                  }}
                  value={lotFrom}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Yard To"}</label>
              </div>
              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard To"}
                  isDisabled={false}
                  options={lotToArr}
                  onChange={(value) => {
                    setLotTo(value);
                  }}
                  value={lotTo}
                />
              </div>
            </div>
          </div>
        ) : null}

        {moveType?.value == "DC2YARD" || moveType?.value == "DC2DC" ? null : (
          <div className="container ">
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <label className="ml-10" style={{ fontSize: 14 }}>
                <input
                  type="radio"
                  checked={isTrailer}
                  disabled={
                    (moveType?.value == "DOOROUT" ||
                      moveType?.value == "RESET" ||
                      (moveType?.value == "DOOR2DOOR" && doorFrom != null)) &&
                    containerId?.value != "" &&
                    containerId?.value != null
                      ? true
                      : false
                  }
                  onClick={() => {
                    setIsTrailer(true);
                    setIsContainer(false);
                    setContainerId("");
                  }}
                  value="Trailer"
                />
                Trailer
              </label>

              {moveType &&
              (moveType?.value == "DOORIN" ||
                moveType?.value == "DOOROUT" ||
                moveType?.value == "DOOR2DOOR" ||
                moveType?.value == "RESET") ? (
                <label style={{ fontSize: 14 }}>
                  <input
                    type="radio"
                    checked={isContainer}
                    disabled={
                      (moveType?.value == "DOOROUT" ||
                        moveType?.value == "RESET" ||
                        (moveType?.value == "DOOR2DOOR" && doorFrom != null)) &&
                      trailerId?.value != "" &&
                      trailerId?.value != null
                        ? true
                        : false
                    }
                    onClick={() => {
                      setIsTrailer(false);
                      setIsContainer(true);
                      setTrailerId("");
                    }}
                    value="Container"
                  />{" "}
                  Container
                </label>
              ) : (
                <div />
              )}
            </div>
          </div>
        )}

        {moveType?.value == "DC2YARD" || moveType?.value == "DC2DC" ? null : (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            {props.keyData == "InProgressRequest" ? null : isTrailer ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Trailer Id Search</label>
                </div>
                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    isDisabled={isTrailer && isTrailerContainerChecked}
                    name={"Select Trailer Id"}
                    options={trailerIdArray}
                    onChange={(value) => {
                      if (
                        (moveType?.value == "SPACE2SPACE" ||
                          moveType?.value == "DOOROUT" ||
                          (moveType?.value == "DOOR2DOOR" &&
                            doorFrom != null)) &&
                        trailerId?.value != "" &&
                        trailerId?.value != null
                      ) {
                        alert(
                          "Trailer already in space ,you cannot choose another trailer"
                        );
                      } else {
                        setTrailerId(value);
                        setCurrentLocation("");
                        let obj = {
                          id: value?.value != undefined ? value.value : 0,
                        };
                        dispatch({
                          type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                            .GET_RURAL_TRAILER_LOGS_API_CALL,
                          payload: { value: obj },
                        });
                        setPreviousLoadVolume({
                          value: value?.prevLoadVolume,
                          label: value?.prevLoadVolume,
                        });
                      }
                    }}
                    value={trailerId}
                  />
                </div>
              </div>
            ) : moveType &&
              (moveType?.value == "DOORIN" ||
                moveType?.value == "DOOROUT" ||
                moveType?.value == "DOOR2DOOR" ||
                moveType?.value == "RESET") ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Container</label>
                </div>
                <div className="row wrapper col-12 col-md-12 p-0 col-sm-12 col-lg-12 ">
                  <div
                    style={{
                      display: "flex",
                      padding: 0,
                      margin: 0,
                      flexDirection: "row",
                    }}
                    className={"row col-10 col-md-10 col-sm-10 col-lg-10"}
                  >
                    <CreatableSelect
                      isClearable={false}
                      className="Containerclass"
                      allowCreateWhileLoading={false}
                      ref={creatableInputRef}
                      onChange={(val) => {
                        if (
                          (moveType?.value == "DOOROUT" ||
                            (moveType?.value == "DOOR2DOOR" &&
                              doorFrom != null)) &&
                          containerId?.value != "" &&
                          containerId?.value != null
                        ) {
                          alert(
                            "Container  already in Selected ,you cannot choose another Container"
                          );
                        } else {
                          setContainerId(val);
                        }
                      }}
                      onInputChange={(newTextValue, actionMeta) => {
                        if (actionMeta?.action == "clear") {
                          setPage(0);
                        } else if (
                          newTextValue?.__isNew__ &&
                          newTextValue?.__isNew__ == true
                        ) {
                          setContainerId(newTextValue);
                          let obj = { btId: newTextValue, is_active: true };
                          dispatch({
                            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                              .CREATE_CONTAINER_API_CALL,
                            payload: { value: obj },
                          });
                        } else {
                          if (newTextValue != "") {
                            setContainerId({
                              value: newTextValue,
                              label: newTextValue,
                            });
                            Promise.resolve(callSomeApi(newTextValue));
                          }
                        }
                      }}
                      placeholder={"Select Container"}
                      options={containerIdArray}
                      value={containerId}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      borderRadius: 4,
                      borderWidth: 2,
                      borderColor: "#D3D3D3",
                    }}
                    className="col-2 col-md-2 p-0 col-sm-2 col-lg-2 "
                  >
                    {containerId &&
                    containerId != "" &&
                    containerId?.value != "" ? (
                      <img
                        onClick={() => {
                          if (
                            (moveType?.value == "DOOROUT" ||
                              (moveType?.value == "DOOR2DOOR" &&
                                doorFrom != null)) &&
                            containerId?.value != "" &&
                            containerId?.value != null
                          ) {
                            alert(
                              "Container  already in Selected ,you cannot choose another Container"
                            );
                          } else {
                            setContainerId("");
                            setContainerIdArray([]);
                            setCreateContainerEnable(false);
                          }
                        }}
                        src={require("./../assets/Dashboard/clear1.png")}
                        style={{ width: 12, marginRight: 10, height: 12 }}
                      ></img>
                    ) : null}
                    {createContainerEnable && containerId != "" ? (
                      <img
                        onClick={() => {
                          let obj = {
                            btId: containerId?.value,
                            is_active: true,
                          };
                          dispatch({
                            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                              .CREATE_CONTAINER_API_CALL,
                            payload: { value: obj },
                          });
                          setCreateContainerEnable(false);
                        }}
                        src={require("./../assets/Dashboard/plus.png")}
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                          height: 20,
                          width: 20,
                        }}
                      ></img>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                          height: 20,
                          width: 20,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ) : null}

            {props?.keyData == "InProgressRequest" ? null : trailerId != "" ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>
                    Current Trailer Location
                  </label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      height: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "8px",
                      fontSize: 14,
                    }}
                    labelName={"Current Location"}
                    placeholder={"Select Current Location"}
                    value={currentLocation}
                    isDisabled={true}
                  />
                </div>
              </div>
            ) : null}

            {moveType?.value != "DOORIN" || isContainer ? null : (
              <div className="col-md-6 col-6 col-sm-6 col-lg-4 d-flex justify-content-around mt-4">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <label style={{ fontSize: 14 }}> {isTrailer ? "Request Empty Trailer" : "Request Empty Container"}</label> */}
                  <label style={{ fontSize: 14 }}>
                    {" "}
                    {isTrailer ? "Request Empty Trailer" : ""}
                  </label>
                </div>
                {isTrailer ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CheckboxComponent
                      isDisabled={
                        moveType && moveType?.value == "DOOROUT" ? true : false
                      }
                      checked={isTrailerContainerChecked}
                      onChange={(isChecked) => {
                        setTrailerId("");
                        setCurrentLocation("");
                        setIsTrailerContainerChecked(isChecked);
                      }}
                    />
                  </div>
                ) : null}
              </div>
            )}
          </div>
        )}

        {/* //Load Volume */}
        {/* 2 */}
        {props.keyData == "InProgressRequest" ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            {isTrailer ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Trailer Id Search</label>
                </div>
                <div>
                  <DropDownComp
                    styles={{
                      height: 35,
                      display: "flex",
                      flexDirection: "row",

                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      fontSize: 14,
                    }}
                    name={"Select Trailer Id"}
                    options={trailerIdArray}
                    isDisabled={isTrailerContainerChecked}
                    onChange={(value) => {
                      if (
                        (moveType?.value == "SPACE2SPACE" ||
                          moveType?.value == "DOOROUT" ||
                          (moveType?.value == "DOOR2DOOR" &&
                            doorFrom != null)) &&
                        trailerId?.value != "" &&
                        trailerId?.value != null
                      ) {
                        alert(
                          "Trailer already in space ,you cannot choose another trailer"
                        );
                      } else {
                        setTrailerId(value);
                        setCurrentLocation("");
                        let obj = {
                          id: value?.value != undefined ? value.value : 0,
                        };
                        dispatch({
                          type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
                            .GET_RURAL_TRAILER_LOGS_API_CALL,
                          payload: { value: obj },
                        });
                        setPreviousLoadVolume({
                          value: value.prevLoadVolume,
                          label: value.prevLoadVolume,
                        });
                      }
                    }}
                    value={trailerId}
                  />
                </div>
              </div>
            ) : moveType &&
              (moveType?.value == "DOORIN" ||
                moveType?.value == "DOOROUT" ||
                moveType?.value == "DOOR2DOOR") ? (
              <div className="row wrapper col-12 col-md-12 col-sm-12 col-lg-12 ">
                <div className="row wrapper col-12 col-md-12 p-0 col-sm-12 col-lg-12 ">
                  <div
                    style={{
                      display: "flex",
                      padding: 0,
                      margin: 0,
                      flexDirection: "row",
                    }}
                    className={"row col-10 col-md-10 col-sm-10 col-lg-10"}
                  >
                    <CreatableSelect
                      isClearable={false}
                      className="Containerclass"
                      allowCreateWhileLoading={false}
                      ref={creatableInputRef}
                      onChange={(val) => {
                        setContainerId(val);
                      }}
                      onInputChange={(newTextValue, actionMeta) => {
                        if (actionMeta?.action == "clear") {
                          setPage(0);
                        } else if (
                          newTextValue?.__isNew__ &&
                          newTextValue?.__isNew__ == true
                        ) {
                          setContainerId(newTextValue);
                          let obj = { btId: newTextValue, is_active: true };
                          dispatch({
                            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                              .CREATE_CONTAINER_API_CALL,
                            payload: { value: obj },
                          });
                        } else {
                          if (newTextValue != "") {
                            setContainerId({
                              value: newTextValue,
                              label: newTextValue,
                            });
                            Promise.resolve(callSomeApi(newTextValue));
                          }
                        }
                      }}
                      placeholder={"Select Container"}
                      options={containerIdArray}
                      value={containerId}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      borderRadius: 4,
                      borderWidth: 2,
                      borderColor: "#D3D3D3",
                    }}
                    className="col-2 col-md-2 p-0 col-sm-2 col-lg-2 "
                  >
                    {containerId &&
                    containerId != "" &&
                    containerId?.value != "" ? (
                      <img
                        onClick={() => {
                          setContainerId("");
                          setContainerIdArray([]);
                          setCreateContainerEnable(false);
                        }}
                        src={require("./../assets/Dashboard/clear1.png")}
                        style={{ width: 12, marginRight: 10, height: 12 }}
                      ></img>
                    ) : null}
                    {createContainerEnable && containerId != "" ? (
                      <img
                        onClick={() => {
                          let obj = {
                            btId: containerId?.value,
                            is_active: true,
                          };
                          dispatch({
                            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                              .CREATE_CONTAINER_API_CALL,
                            payload: { value: obj },
                          });
                          setCreateContainerEnable(false);
                        }}
                        src={require("./../assets/Dashboard/plus.png")}
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                          height: 20,
                          width: 20,
                        }}
                      ></img>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                          height: 20,
                          width: 20,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="col-12 col-md-12 col-sm-12 col-lg-4">
              <div>
                <label style={{ fontSize: 14 }}>{"Previous Load Volume"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Previous Load Volume"}
                  options={loadVolumeArr}
                  onChange={(value) => {
                    setPreviousLoadVolume(value);
                  }}
                  isDisabled={true}
                  value={previousLoadVolume}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>{"New Load Volume"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select New Load Volume"}
                  options={loadVolumeArr}
                  onChange={(value) => {
                    setNewLoadVolume(value);
                  }}
                  value={newLoadVolume}
                />
              </div>
            </div>
          </div>
        ) : (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4">
              <div>
                <label style={{ fontSize: 14 }}>Driver</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Driver"}
                  options={driverTypeArr}
                  onChange={(value) => {
                    setDriver(value);
                  }}
                  isDisabled={
                    loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.RHUSER
                      ? true
                      : false
                  }
                  value={driver}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>Truck</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Truck"}
                  options={truckTypeArr}
                  onChange={(value) => {
                    setTruck(value);
                  }}
                  value={truck}
                  isDisabled={
                    loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.RHUSER
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
        )}

        {props.keyData == "InProgressRequest" ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            {trailerId != "" ? (
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>
                    Current Trailer Location
                  </label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      height: "100%",
                      borderColor: "hsl(0, 0%, 50%)",

                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "8px",
                      fontSize: 14,
                    }}
                    labelName={"Current Location"}
                    placeholder={"Select Current Location"}
                    value={currentLocation}
                    isDisabled={true}
                  />
                </div>
              </div>
            ) : null}
            <div className="col-12 col-md-12 col-sm-12 col-lg-4">
              <div>
                <label style={{ fontSize: 14 }}>Driver</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",

                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Driver"}
                  options={driverTypeArr}
                  onChange={(value) => {
                    setDriver(value);
                  }}
                  isDisabled={
                    loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.RHUSER
                      ? true
                      : false
                  }
                  value={driver}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>Truck</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Truck"}
                  options={truckTypeArr}
                  onChange={(value) => {
                    setTruck(value);
                  }}
                  isDisabled={
                    loginResponse?.user?.userRoles[0]?.user_role_name ==
                    CONSTANTS.CONSTANTS_USER_ROLES.RHUSER
                      ? true
                      : false
                  }
                  value={truck}
                />
              </div>
            </div>
          </div>
        ) : null}

        {moveType?.value == "DC2YARD" || moveType?.value == "DC2DC" ? null : (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
              <div>
                <label style={{ fontSize: 14 }}>Seal Number</label>
              </div>

              <div>
                <InputComp
                  style={{
                    height: "100%",
                    width: "100%",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    padding: "8px",
                    fontSize: 14,
                  }}
                  labelName={"Seal Number"}
                  maxLength={30}
                  placeholder={"Seal Number"}
                  value={sealNumber}
                  onChangeHandler={(sealNumber) => {
                    setSealNumber(sealNumber);
                  }}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
              <div>
                <label style={{ fontSize: 14 }}>Product Number</label>
              </div>

              <div>
                <InputComp
                  style={{
                    height: "100%",
                    width: "100%",
                    borderColor: "hsl(0, 0%, 50%)",

                    borderStyle: "solid",
                    borderWidth: "1px",
                    padding: "8px",
                    fontSize: 14,
                  }}
                  labelName={"Product Number"}
                  maxLength={30}
                  placeholder={"Product Number"}
                  value={productNumber}
                  onChangeHandler={(productNumber) => {
                    setProductNumber(productNumber);
                  }}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2 ">
              <div>
                <label style={{ fontSize: 14 }}>Actual Count</label>
              </div>

              <div>
                <InputComp
                  style={{
                    height: "100%",
                    width: "100%",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    padding: "8px",
                    fontSize: 14,
                  }}
                  labelName={"Actual Count"}
                  maxLength={30}
                  placeholder={"Actual Count"}
                  value={actualCount}
                  onChangeHandler={(actualCount) => {
                    setActualCount(actualCount);
                  }}
                />
              </div>
            </div>

            {/* </div> */}
          </div>
        )}
        {moveType?.value == "DC2YARD" || moveType?.value == "DC2DC" ? null : (
          <div
            className="row container d-flex mt-1 col-12 col-md-12 col-sm-12 col-lg-12"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <div
              className="row container d-flex col-12 col-md-12 col-sm-12 col-lg-6"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <div>
                <label style={{ fontSize: 14 }}>
                  {" "}
                  {"Comments : Before / During"}
                </label>
              </div>

              <div>
                <InputComp
                  style={{
                    height: "100%",
                    borderStyle: "solid",
                    borderWidth: "2px",
                    padding: "4px",
                    fontSize: 14,
                    borderColor: "hsl(0, 0%, 50%)",
                  }}
                  labelName={"Comments"}
                  isMulti={true}
                  placeholder={"Comments"}
                  value={comment}
                  isDisabled={
                    props.keyData == "InProgressRequest" ? true : false
                  }
                  onChangeHandler={(comment) => {
                    setComment(comment);
                  }}
                />
              </div>
            </div>

            {props.OffSite ? null : props.keyData == "InProgressRequest" ? (
              <div
                className="row container d-flex col-12 col-md-12 col-sm-12 col-lg-6"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <label style={{ fontSize: 14 }}>
                    {" "}
                    {"Comments: After Comments"}
                  </label>
                </div>

                <div>
                  <InputComp
                    style={{
                      height: "100%",

                      borderStyle: "solid",
                      borderWidth: "2px",
                      padding: "4px",
                      fontSize: 14,
                      borderColor: "hsl(0, 0%, 50%)",
                    }}
                    labelName={"Comments"}
                    isMulti={true}
                    placeholder={"Comments"}
                    value={afterComment}
                    onChangeHandler={(comment) => {
                      setAfterComment(comment);
                    }}
                  />
                </div>
              </div>
            ) : null}
          </div>
        )}

        <div className="col-md-6 col-6 col-sm-6 col-lg-4 d-flex justify-content-around mt-4">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <label style={{ fontSize: 14 }}>Priority Move</label>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckboxComponent
              checked={priorityMove}
              onChange={(isChecked) => {
                setIsPriorityMove(isChecked);
              }}
            />
          </div>
        </div>

        {/* } */}

        {props.keyData == "InProgressRequest" ? (
          <view
            className="row container"
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "auto",
            }}
          >
            <div
              className="row col-4 col-md-4 col-4 col-sm-4 col-lg-4"
              style={{
                flex: 1,
              }}
            >
              <label style={{ fontSize: 14 }}>
                {" "}
                {"Reason for Cancellation  : "}
              </label>
            </div>
            <div className="row col-4 col-md-4 col-4 col-sm-4 col-lg-4">
              <DropDownComp
                styles={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",

                  fontSize: 14,
                }}
                name={"Select Reason"}
                options={reasonCancellationArr}
                onChange={(value) => {
                  setReasonForCancellation(value);
                }}
                value={reasonForCancellation}
              />
            </div>

            <div className="row col-4 col-md-4 col-4 col-sm-4 col-lg-4" />
          </view>
        ) : null}
      </Modal.Body>

      <Modal.Footer>
        <div
          className="row col-12 col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          {loginResponse?.user?.userRoles[0]?.user_role_name !==
            CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
          props.rowDataUser &&
          props.rowDataUser != null ? (
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <button
                onClick={async () => {
                  if (
                    driver == "" &&
                    requestTime == "" &&
                    changeType == "" &&
                    departmentType == "" &&
                    requesterName == "" &&
                    productNumber == "" &&
                    actualCount == "" &&
                    sealNumber == "" &&
                    comment == "" &&
                    truck == ""
                  ) {
                    alert("All Fields are compulsory");
                  } else {
                    try {
                      if (props.rowDataUser && props.rowDataUser != null) {
                        //update move

                        let payload = {
                          is_active: true,
                          move_id: props.rowDataUser.move_id,
                          user_id: requesterName?.value, // change to number
                          division_id: division?.value,
                          changeType: moveType?.value, //Move type
                          requestDateTime: new Date(requestTime),
                          requesterName: requesterName?.label,
                          trailer_id: trailerId?.value ? trailerId.value : null,
                          outsideCarrierContainer_id:
                            containerId?.value || null,
                          doorToId:
                            moveType?.value == "DOORIN" ||
                            moveType?.value == "RESET"
                              ? doorTo?.value
                              : moveType?.value == "DOOR2DOOR" && doorTo?.value
                              ? doorTo?.value
                              : null,
                          doorFromId:
                            moveType?.value == "DOOROUT" ||
                            moveType?.value == "DOOR2DOOR"
                              ? doorFrom?.value
                              : moveType?.value == "DOORIN" ||
                                moveType?.value == "RESET"
                              ? doorFrom?.value
                              : null,
                          locationFromId:
                            (moveType?.value == "Off Site" ||
                              moveType?.value == "DOORIN" ||
                              moveType?.value == "RESET") &&
                            locationFrom?.value
                              ? locationFrom.value
                              : null,
                          locationToId:
                            moveType?.value == "Off Site" && locationTo?.value
                              ? locationTo.value
                              : null,
                          spaceFromId:
                            spaceFrom != null ? spaceFrom?.value : null,
                          spaceToId:
                            moveType?.value == "DC2YARD"
                              ? spaceDC2SpaceValue?.value
                              : spaceTo != null
                              ? spaceTo?.value
                              : null,
                          department:
                            moveType?.value == "SPACE2SPACE"
                              ? departmentType?.value
                              : department?.value || null,
                          productNum: productNumber,
                          actualCount: actualCount,
                          sealNum: sealNumber,
                          driver_id: driver?.value,
                          truck_id: truck?.value,
                          startDateTime: new Date(requestTime),
                          finishDateTime: new Date(),
                          beforeComments: comment,
                          afterComments:
                            props.keyData == "InProgressRequest"
                              ? afterComment
                              : "",
                          priorityMove: priorityMove, // true  false ,
                          completed: !props.isUpdate
                            ? props.keyData == "PendingRequest"
                              ? 0
                              : props.keyData == "InProgressRequest"
                              ? 1
                              : props.rowDataUser.completed
                            : props.rowDataUser.completed,
                          pending: !props.isUpdate
                            ? props.keyData == "PendingRequest"
                              ? 0
                              : props.keyData == "InProgressRequest"
                              ? 0
                              : props.rowDataUser.pending
                            : props.rowDataUser.pending,
                          requestFlag:
                            props.keyData == "InProgressRequest"
                              ? reasonForCancellation?.value
                              : "",
                          isEmpty:
                            trailerId != null
                              ? false
                              : isTrailerContainerChecked,
                          lotFromId: lotFrom?.value,
                          lotToId: lotTo?.value,
                          divisionToId:
                            moveType?.value == "DC2YARD"
                              ? divisionDC2DC
                              : divisionTo?.value,
                          totalTime:
                            props.keyTitle == moveTypeStatus.CompleteStatus
                              ? Math.floor(
                                  (new Date() - new Date(requestTime)) / 60000
                                )
                              : null,
                          is_cancelled: false,
                          prevLoadVolume:
                            previousLoadVolume != ""
                              ? previousLoadVolume?.value
                              : "",
                          newLoadVolume:
                            newLoadVolume != "" ? newLoadVolume?.value : "",
                        };
                        if (props.title === "Move to Complete Request") {
                          if (moveType.value === "DOORIN") {
                            const response1 = await getCurrentDoorOccupancy(
                              payload.doorToId
                            );
                            const doorOccupany =
                              response1?.data[0]?.currentOccupancy;
                            if (doorOccupany != null) {
                              alert("Currently Door is occupied");

                              return;
                            }
                          }
                          if (
                            moveType.value === "SPACE2SPACE" ||
                            (moveType.value === "DOOROUT" &&
                              payload.spaceToId != null)
                          ) {
                            const response2 = await getCurrentSpaceOccupancy(
                              payload.spaceToId
                            );
                            const spaceOccupany =
                              response2?.data[0]?.currentOccupancy;
                            if (spaceOccupany != null) {
                              alert("Currently Space is occupied");
                              return;
                            }
                          }
                        }
                        if (props.title === "Move to InProgress Request") {
                          if (payload.driver_id && !isTrailerContainerChecked) {
                            if (
                              !payload.trailer_id &&
                              !payload.outsideCarrierContainer_id
                            ) {
                              alert("Please select trailer or Container");
                              return;
                            }
                          }
                        }
                        if (
                          moveType &&
                          moveType?.value != "YARD2YARD" &&
                          moveType?.value != "SPACE2SPACE" &&
                          props.keyTitle == moveTypeStatus.CompleteStatus &&
                          isTrailer &&
                          (trailerId?.value === "" ||
                            trailerId?.value === null ||
                            trailerId?.value === undefined)
                        ) {
                          alert("Please Select Trailer");
                        } else if (
                          moveType &&
                          moveType?.value != "YARD2YARD" &&
                          moveType?.value != "SPACE2SPACE" &&
                          props.keyTitle == moveTypeStatus.CompleteStatus &&
                          isContainer &&
                          (containerId?.value === "" ||
                            containerId?.value === null ||
                            containerId?.value === undefined)
                        ) {
                          alert("Please Select Container");
                        } else if (
                          (driver == null || driver == "") &&
                          (props.keyTitle == moveTypeStatus.InProgressStatus ||
                            props.keyTitle == moveTypeStatus.CompleteStatus ||
                            (props.keyTitle == moveTypeStatus.UpdateStatus &&
                              props.keyData == "InProgressRequest"))
                        ) {
                          alert("Please Select Driver");
                        } else if (
                          (departmentType == null || departmentType == "") &&
                          (department == null || department == "")
                        ) {
                          alert("Please Select department");
                        } else {
                          if (
                            moveType?.value == "DOORIN" &&
                            (doorTo == "" || doorTo == null)
                          ) {
                            alert("Please Select Door");
                          } else if (
                            moveType?.value == "SPACE2SPACE" &&
                            props.keyTitle == moveTypeStatus.CompleteStatus
                          ) {
                            if (lotFrom == "" || lotFrom == null) {
                              alert("Please Select Yard From");
                            } else if (lotTo == "" || lotTo == null) {
                              alert("Please Select Yard To");
                            } else if (spaceTo == "" || spaceTo == null) {
                              alert("Please Select Space To");
                            } else if (spaceFrom == "" || spaceFrom == null) {
                              alert("Please Select Space From");
                            } else {
                              props.setValue(payload);
                            }
                          } else if (
                            moveType?.value == "DOOROUT" &&
                            props.keyTitle == moveTypeStatus.CompleteStatus
                          ) {
                            if (lotTo == "" || lotTo == null) {
                              alert("Please Select Yard To");
                            } else if (spaceTo == "" || spaceTo == null) {
                              alert("Please Select Space To");
                            } else {
                              props.setValue(payload);
                            }
                          } else if (moveType?.value == "DOOR2DOOR") {
                            if (doorFrom == "" || doorFrom == null) {
                              alert("Please Select Door From");
                            } else if (
                              (doorTo == "" || doorTo == null) &&
                              props.keyTitle == moveTypeStatus.CompleteStatus
                            ) {
                              alert("Please Select Door To");
                            } else {
                              props.setValue(payload);
                            }
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        }
                      } else {
                        setIsCancelClicked(false);
                        //create move
                        let payload = {
                          user_id: requesterName?.value, // change to number
                          division_id: division.value,
                          changeType:
                            moveType?.value == "DC2YARD"
                              ? "DC2YARD"
                              : moveType?.value, //Move type
                          requestDateTime: requestTime,
                          requesterName: requesterName?.label,
                          trailer_id: trailerId?.value ? trailerId.value : null,
                          outsideCarrierContainer_id:
                            containerId?.value || null,
                          doorToId:
                            moveType?.value == "DOOR2DOOR" && doorTo?.value
                              ? doorTo?.value
                              : (moveType?.value == "DOORIN" ||
                                  moveType?.value == "RESET") &&
                                doorTo?.value
                              ? doorTo.value
                              : null,
                          doorFromId:
                            (moveType?.value == "DOOROUT" ||
                              moveType?.value == "DOOR2DOOR") &&
                            doorFrom?.value
                              ? doorFrom.value
                              : moveType?.value == "DOORIN" ||
                                moveType?.value == "RESET"
                              ? doorFrom?.value
                              : null,
                          spaceFromId: spaceFrom?.value
                            ? spaceFrom.value
                            : null,
                          spaceToId:
                            moveType?.value == "DC2YARD"
                              ? spaceDC2SpaceValue?.value
                              : spaceTo != null
                              ? spaceTo?.value
                              : null,
                          locationFromId:
                            moveType?.value == "Off Site" && locationFrom?.value
                              ? locationFrom.value
                              : null,
                          locationToId:
                            moveType?.value == "Off Site" && locationTo?.value
                              ? locationTo.value
                              : null,
                          department:
                            moveType?.value == "SPACE2SPACE"
                              ? departmentType?.value
                              : department?.value || null,
                          productNum: productNumber,
                          actualCount: actualCount,
                          sealNum: sealNumber,
                          startDateTime: new Date(),
                          finishDateTime: null,
                          beforeComments: comment,
                          afterComments: "",
                          driver_id: driver?.value || null,
                          truck_id: truck?.value || null,
                          priorityMove: priorityMove, // true  false ,
                          pending: 1,
                          completed: 0,
                          requestFlag:
                            props.keyData == "InProgressRequest"
                              ? reasonForCancellation?.value
                              : "",
                          isEmpty:
                            trailerId != null && trailerId != ""
                              ? false
                              : isTrailerContainerChecked,
                          lotFromId: lotFrom?.value || null,
                          lotToId: lotTo?.value || null,
                          divisionToId: divisionTo?.value || null,
                          totalTime: null,
                          is_cancelled: false,
                          is_active: true,
                          prevLoadVolume:
                            previousLoadVolume != ""
                              ? previousLoadVolume?.value
                              : "",
                          newLoadVolume:
                            newLoadVolume != "" ? newLoadVolume?.value : "",
                        };
                        if (moveType == "" || moveType == null) {
                          alert("Please Select Move Type");
                        } else if (
                          moveType?.value == "DOORIN" &&
                          (doorTo == "" ||
                            doorTo == null ||
                            doorTo == undefined)
                        ) {
                          alert("Please Select Door");
                        } else if (
                          moveType?.value == "DOOROUT" &&
                          (doorFrom == "" ||
                            doorFrom == null ||
                            doorFrom == undefined)
                        ) {
                          alert("Please Select Door");
                        } else if (
                          (departmentType == null || departmentType == "") &&
                          (department == null || department == "")
                        ) {
                          alert("Please Select department");
                        } else if (moveType?.value == "DOOR2DOOR") {
                          if (doorFrom == "" || doorFrom == null) {
                            alert("Please Select Door From");
                          } else {
                            setCurrentLocation("");
                            setContainerId("");
                            props.setValue(payload);
                          }
                        } else {
                          setCurrentLocation("");
                          setContainerId("");
                          props.setValue(payload);
                        }
                      }
                    } catch (e) {}
                  }
                }}
                style={{
                  backgroundColor: "#002a4a",
                  height: "80%",
                  color: "white",
                  width: "100%",
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                className="btn btn-primary"
                variant="primary"
              >
                {props.title}
              </button>
            </div>
          ) : null}
          {props.rowDataUser && props.rowDataUser != null ? null : (
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <button
                onClick={() => {
                  if (
                    driver == "" &&
                    requestTime == "" &&
                    changeType == "" &&
                    departmentType == "" &&
                    requesterName == "" &&
                    productNumber == "" &&
                    actualCount == "" &&
                    sealNumber == "" &&
                    comment == "" &&
                    truck == ""
                  ) {
                    alert("All Fields are compulsory");
                  } else {
                    try {
                      if (props.rowDataUser && props.rowDataUser != null) {
                        //update move
                        let payload = {
                          is_active: true,
                          move_id: props.rowDataUser.move_id,
                          user_id: requesterName?.value, // change to number
                          division_id: division?.value,
                          changeType: moveType?.value, //Move type
                          requestDateTime: new Date(requestTime),
                          requesterName: requesterName?.label,
                          trailer_id: trailerId?.value ? trailerId.value : null,
                          outsideCarrierContainer_id:
                            containerId?.value || null,
                          doorToId:
                            moveType?.value == "DOORIN" ||
                            moveType?.value == "RESET"
                              ? doorTo?.value
                              : moveType?.value == "DOOR2DOOR" && doorTo?.value
                              ? doorTo?.value
                              : null,
                          doorFromId:
                            moveType?.value == "DOOROUT" ||
                            moveType?.value == "DOOR2DOOR"
                              ? doorFrom?.value
                              : moveType?.value == "DOORIN" ||
                                moveType?.value == "RESET"
                              ? doorFrom?.value
                              : null,
                          locationFromId:
                            (moveType?.value == "Off Site" ||
                              moveType?.value == "DOORIN" ||
                              moveType?.value == "RESET") &&
                            locationFrom?.value
                              ? locationFrom.value
                              : null,
                          locationToId:
                            moveType?.value == "Off Site" && locationTo?.value
                              ? locationTo.value
                              : null,
                          spaceFromId:
                            spaceFrom != null ? spaceFrom?.value : null,
                          spaceToId:
                            moveType?.value == "DC2YARD"
                              ? spaceDC2SpaceValue?.value
                              : spaceTo != null
                              ? spaceTo?.value
                              : null,
                          department:
                            moveType?.value == "SPACE2SPACE"
                              ? departmentType?.value
                              : department?.value || null,
                          productNum: productNumber,
                          actualCount: actualCount,
                          sealNum: sealNumber,
                          driver_id: driver?.value,
                          truck_id: truck?.value,
                          startDateTime: new Date(requestTime),
                          finishDateTime: new Date(),
                          beforeComments: comment,
                          afterComments:
                            props.keyData == "InProgressRequest"
                              ? afterComment
                              : "",
                          priorityMove: priorityMove, // true  false ,
                          completed: !props.isUpdate
                            ? props.keyData == "PendingRequest"
                              ? 0
                              : props.keyData == "InProgressRequest"
                              ? 1
                              : props.rowDataUser.completed
                            : props.rowDataUser.completed,
                          pending: !props.isUpdate
                            ? props.keyData == "PendingRequest"
                              ? 0
                              : props.keyData == "InProgressRequest"
                              ? 0
                              : props.rowDataUser.pending
                            : props.rowDataUser.pending,
                          requestFlag:
                            props.keyData == "InProgressRequest"
                              ? reasonForCancellation?.value
                              : "",
                          isEmpty:
                            trailerId != null
                              ? false
                              : isTrailerContainerChecked,
                          lotFromId: lotFrom?.value,
                          lotToId: lotTo?.value,
                          divisionToId:
                            moveType?.value == "DC2YARD"
                              ? divisionDC2DC
                              : divisionTo?.value,
                          totalTime:
                            props.keyTitle == moveTypeStatus.CompleteStatus
                              ? Math.floor(
                                  (new Date() - new Date(requestTime)) / 60000
                                )
                              : null,
                          is_cancelled: false,
                          prevLoadVolume:
                            previousLoadVolume != ""
                              ? previousLoadVolume?.value
                              : "",
                          newLoadVolume:
                            newLoadVolume != "" ? newLoadVolume?.value : "",
                        };
                        if (
                          moveType &&
                          moveType?.value != "YARD2YARD" &&
                          moveType?.value != "SPACE2SPACE" &&
                          props.keyTitle == moveTypeStatus.CompleteStatus &&
                          isTrailer &&
                          (trailerId?.value === "" ||
                            trailerId?.value === null ||
                            trailerId?.value === undefined)
                        ) {
                          alert("Please Select Trailer");
                        } else if (
                          moveType &&
                          moveType?.value != "YARD2YARD" &&
                          moveType?.value != "SPACE2SPACE" &&
                          props.keyTitle == moveTypeStatus.CompleteStatus &&
                          isContainer &&
                          (containerId?.value === "" ||
                            containerId?.value === null ||
                            containerId?.value === undefined)
                        ) {
                          alert("Please Select Container");
                        } else if (
                          (driver == null || driver == "") &&
                          (props.keyTitle == moveTypeStatus.InProgressStatus ||
                            props.keyTitle == moveTypeStatus.CompleteStatus ||
                            (props.keyTitle == moveTypeStatus.UpdateStatus &&
                              props.keyData == "InProgressRequest"))
                        ) {
                          alert("Please Select Driver");
                        } else if (
                          (departmentType == null || departmentType == "") &&
                          (department == null || department == "")
                        ) {
                          alert("Please Select department");
                        } else {
                          if (
                            moveType?.value == "DOORIN" &&
                            (doorTo == "" || doorTo == null)
                          ) {
                            alert("Please Select Door");
                          } else if (
                            moveType?.value == "SPACE2SPACE" &&
                            props.keyTitle == moveTypeStatus.CompleteStatus
                          ) {
                            if (lotFrom == "" || lotFrom == null) {
                              alert("Please Select Yard From");
                            } else if (lotTo == "" || lotTo == null) {
                              alert("Please Select Yard To");
                            } else if (spaceTo == "" || spaceTo == null) {
                              alert("Please Select Space To");
                            } else if (spaceFrom == "" || spaceFrom == null) {
                              alert("Please Select Space From");
                            } else {
                              props.setValue(payload);
                            }
                          } else if (
                            moveType?.value == "DOOROUT" &&
                            props.keyTitle == moveTypeStatus.CompleteStatus
                          ) {
                            if (lotTo == "" || lotTo == null) {
                              alert("Please Select Yard To");
                            } else if (spaceTo == "" || spaceTo == null) {
                              alert("Please Select Space To");
                            } else {
                              props.setValue(payload);
                            }
                          } else if (moveType?.value == "DOOR2DOOR") {
                            if (doorFrom == "" || doorFrom == null) {
                              alert("Please Select Door From");
                            } else if (
                              (doorTo == "" || doorTo == null) &&
                              props.keyTitle == moveTypeStatus.CompleteStatus
                            ) {
                              alert("Please Select Door To");
                            } else {
                              props.setValue(payload);
                            }
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        }
                      } else {
                        setIsCancelClicked(false);
                        //create move
                        let payload = {
                          user_id: requesterName?.value, // change to number
                          division_id: division.value,
                          changeType:
                            moveType?.value == "DC2YARD"
                              ? "DC2YARD"
                              : moveType?.value, //Move type
                          requestDateTime: requestTime,
                          requesterName: requesterName?.label,
                          trailer_id: trailerId?.value ? trailerId.value : null,
                          outsideCarrierContainer_id:
                            containerId?.value || null,
                          doorToId:
                            moveType?.value == "DOOR2DOOR" && doorTo?.value
                              ? doorTo?.value
                              : (moveType?.value == "DOORIN" ||
                                  moveType?.value == "RESET") &&
                                doorTo?.value
                              ? doorTo.value
                              : null,
                          doorFromId:
                            (moveType?.value == "DOOROUT" ||
                              moveType?.value == "DOOR2DOOR") &&
                            doorFrom?.value
                              ? doorFrom.value
                              : moveType?.value == "DOORIN" ||
                                moveType?.value == "RESET"
                              ? doorFrom?.value
                              : null,
                          spaceFromId: spaceFrom?.value
                            ? spaceFrom.value
                            : null,
                          spaceToId:
                            moveType?.value == "DC2YARD"
                              ? spaceDC2SpaceValue?.value
                              : spaceTo != null
                              ? spaceTo?.value
                              : null,
                          locationFromId:
                            moveType?.value == "Off Site" && locationFrom?.value
                              ? locationFrom.value
                              : null,
                          locationToId:
                            moveType?.value == "Off Site" && locationTo?.value
                              ? locationTo.value
                              : null,
                          department:
                            moveType?.value == "SPACE2SPACE"
                              ? departmentType?.value
                              : department?.value || null,
                          productNum: productNumber,
                          actualCount: actualCount,
                          sealNum: sealNumber,
                          startDateTime: new Date(),
                          finishDateTime: null,
                          beforeComments: comment,
                          afterComments: "",
                          driver_id: driver?.value || null,
                          truck_id: truck?.value || null,
                          priorityMove: priorityMove, // true  false ,
                          pending: 1,
                          completed: 0,
                          requestFlag:
                            props.keyData == "InProgressRequest"
                              ? reasonForCancellation?.value
                              : "",
                          isEmpty:
                            trailerId != null && trailerId != ""
                              ? false
                              : isTrailerContainerChecked,
                          lotFromId: lotFrom?.value || null,
                          lotToId: lotTo?.value || null,
                          divisionToId: divisionTo?.value || null,
                          totalTime: null,
                          is_cancelled: false,
                          is_active: true,
                          prevLoadVolume:
                            previousLoadVolume != ""
                              ? previousLoadVolume?.value
                              : "",
                          newLoadVolume:
                            newLoadVolume != "" ? newLoadVolume?.value : "",
                        };
                        if (moveType == "" || moveType == null) {
                          alert("Please Select Move Type");
                        } else if (
                          moveType?.value == "DOORIN" &&
                          (doorTo == "" ||
                            doorTo == null ||
                            doorTo == undefined)
                        ) {
                          alert("Please Select Door");
                        } else if (
                          moveType?.value == "DOOROUT" &&
                          (doorFrom == "" ||
                            doorFrom == null ||
                            doorFrom == undefined)
                        ) {
                          alert("Please Select Door");
                        } else if (
                          (departmentType == null || departmentType == "") &&
                          (department == null || department == "")
                        ) {
                          alert("Please Select department");
                        } else if (moveType?.value == "DOOR2DOOR") {
                          if (doorFrom == "" || doorFrom == null) {
                            alert("Please Select Door From");
                          } else {
                            setCurrentLocation("");
                            setContainerId("");
                            props.setValue(payload);
                          }
                        } else {
                          setCurrentLocation("");
                          setContainerId("");
                          props.setValue(payload);
                        }
                      }
                    } catch (e) {}
                  }
                }}
                style={{
                  backgroundColor: "#002a4a",
                  height: "80%",
                  color: "white",
                  width: "100%",
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                className="btn btn-primary"
                variant="primary"
              >
                {"Create New Move"}s
              </button>
            </div>
          )}
          {/* } */}

          <div className="col-12 col-sm-12 col-md-4 col-lg-4">
            <button
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              onClick={() => {
                setCurrentLocation("");
                props.show(false);
                setIsCancelClicked(false);
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {props.keyData == "InProgressRequest" ? "Close" : "Cancel"}
            </button>
          </div>

          {props.keyData == "InProgressRequest" &&
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.ADMIN ||
          loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN ||
          loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.DISPATCH ||
          props.rowDataUser?.user_id == loginResponse?.user?.user_id
            ? true
            : false) ? (
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <button
                style={{
                  backgroundColor: "#002a4a",
                  height: "80%",
                  color: "white",
                  width: "100%",
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                onClick={() => {
                  setCurrentLocation("");
                  setIsCancelClicked(true);

                  if (reasonForCancellation.value == "No Issue") {
                    alert("Please Select Reason For Cancellation");
                  } else {
                    let payload = {
                      move_id: props.rowDataUser.move_id,
                      user_id: requesterName?.value, // change to number
                      division_id: division?.value,
                      changeType: moveType?.value, //Move type
                      requestDateTime: new Date(requestTime),
                      requesterName: requesterName?.label,
                      trailer_id: trailerId?.value ? trailerId.value : null,
                      outsideCarrierContainer_id:
                        containerId && containerId != "" && containerId != null
                          ? containerId?.value
                          : null,
                      doorToId:
                        moveType?.value == "DOORIN" ||
                        moveType?.value == "RESET"
                          ? doorTo?.value
                          : moveType?.value == "DOOR2DOOR" && doorTo?.value
                          ? doorTo?.value
                          : null,
                      doorFromId:
                        moveType?.value == "DOOROUT" ||
                        moveType?.value == "DOOR2DOOR"
                          ? doorFrom?.value
                          : null,
                      locationFromId:
                        moveType?.value == "Off Site" && locationFrom?.value
                          ? locationFrom.value
                          : null,
                      locationToId:
                        moveType?.value == "Off Site" && locationTo?.value
                          ? locationTo.value
                          : null,
                      spaceFromId: spaceFrom != null ? spaceFrom?.value : null,
                      spaceToId: spaceTo != null ? spaceTo?.value : null,
                      department:
                        moveType?.value == "SPACE2SPACE"
                          ? departmentType?.value
                          : department?.value || null,
                      productNum: productNumber,
                      actualCount: actualCount,
                      sealNum: sealNumber,
                      driver_id: driver?.value,
                      truck_id: truck?.value,
                      startDateTime: new Date(requestTime),
                      finishDateTime: new Date(),
                      beforeComments: comment,
                      afterComments:
                        props.keyData == "InProgressRequest"
                          ? afterComment
                          : "",
                      priorityMove: priorityMove, // true  false ,
                      completed: 0,
                      pending: 0,
                      requestFlag:
                        props.keyData == "InProgressRequest"
                          ? reasonForCancellation?.value
                          : "",
                      isEmpty:
                        trailerId != null ? false : isTrailerContainerChecked,
                      lotFromId: lotFrom?.value,
                      lotToId: lotTo?.value,
                      divisionToId: divisionTo?.value,
                      totalTime:
                        props.keyTitle == moveTypeStatus.CompleteStatus
                          ? Math.floor(
                              (new Date() - new Date(requestTime)) / 60000
                            )
                          : null,
                      is_cancelled: true,
                      prevLoadVolume:
                        previousLoadVolume != ""
                          ? previousLoadVolume?.value
                          : "",
                      newLoadVolume:
                        newLoadVolume != "" ? newLoadVolume?.value : "",
                    };
                    props.show(false);
                    props.setValue(payload);
                    setContainerId("");
                  }
                }}
                className="btn btn-primary"
                variant="primary"
              >
                {"Cancel Move"}
              </button>
            </div>
          ) : null}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MovesModalComponent;
